export const availableRegions = [
  "Afghanistan",
  "Albania",
  "Algeria",
  "Andorra",
  "Angola",
  "Antigua and Barbuda",
  "Argentina",
  "Armenia",
  "Australia - Australian Capital Territory",
  "Australia - New South Wales",
  "Australia - Queensland",
  "Australia - South Australia",
  "Australia - Tasmania",
  "Australia - Victoria",
  "Australia - Western Australia",
  "Austria",
  "Azerbaijan",
  "Bahamas",
  "Bahrain",
  "Bangladesh",
  "Barbados",
  "Belarus",
  "Belgium - Unknown",
  "Belize",
  "Benin",
  "Bolivia",
  "Bosnia and Herzegovina",
  "Botswana",
  "Brazil - Acre",
  "Brazil - Alagoas",
  "Brazil - Amapa",
  "Brazil - Amazonas",
  "Brazil - Bahia",
  "Brazil - Ceara",
  "Brazil - Distrito Federal",
  "Brazil - Espirito Santo",
  "Brazil - Goias",
  "Brazil - Maranhao",
  "Brazil - Mato Grosso",
  "Brazil - Mato Grosso do Sul",
  "Brazil - Minas Gerais",
  "Brazil - Para",
  "Brazil - Paraiba",
  "Brazil - Parana",
  "Brazil - Pernambuco",
  "Brazil - Piaui",
  "Brazil - Rio Grande do Norte",
  "Brazil - Rio Grande do Sul",
  "Brazil - Rio de Janeiro",
  "Brazil - Rondonia",
  "Brazil - Roraima",
  "Brazil - Santa Catarina",
  "Brazil - Sao Paulo",
  "Brazil - Sergipe",
  "Brazil - Tocantins",
  "Brunei",
  "Bulgaria",
  "Burkina Faso",
  "Burma",
  "Burundi",
  "Cabo Verde",
  "Cameroon",
  "Canada - Alberta",
  "Canada - British Columbia",
  "Canada - Manitoba",
  "Canada - New Brunswick",
  "Canada - Newfoundland and Labrador",
  "Canada - Nova Scotia",
  "Canada - Nunavut",
  "Canada - Ontario",
  "Canada - Quebec",
  "Canada - Saskatchewan",
  "Canada - Yukon",
  "Central African Republic",
  "Chad",
  "Chile - Antofagasta",
  "Chile - Araucania",
  "Chile - Arica y Parinacota",
  "Chile - Atacama",
  "Chile - Aysen",
  "Chile - Biobio",
  "Chile - Coquimbo",
  "Chile - Los Lagos",
  "Chile - Los Rios",
  "Chile - Magallanes",
  "Chile - Maule",
  "Chile - Metropolitana",
  "Chile - Nuble",
  "Chile - OHiggins",
  "Chile - Tarapaca",
  "Chile - Valparaiso",
  "China - Anhui",
  "China - Beijing",
  "China - Chongqing",
  "China - Fujian",
  "China - Gansu",
  "China - Guangdong",
  "China - Guangxi",
  "China - Guizhou",
  "China - Hainan",
  "China - Hebei",
  "China - Heilongjiang",
  "China - Henan",
  "China - Hong Kong",
  "China - Hubei",
  "China - Hunan",
  "China - Inner Mongolia",
  "China - Jiangxi",
  "China - Jilin",
  "China - Liaoning",
  "China - Shaanxi",
  "China - Shandong",
  "China - Shanghai",
  "China - Sichuan",
  "China - Tianjin",
  "China - Xinjiang",
  "China - Yunnan",
  "China - Zhejiang",
  "Colombia - Amazonas",
  "Colombia - Antioquia",
  "Colombia - Arauca",
  "Colombia - Atlantico",
  "Colombia - Bolivar",
  "Colombia - Boyaca",
  "Colombia - Caldas",
  "Colombia - Capital District",
  "Colombia - Caqueta",
  "Colombia - Casanare",
  "Colombia - Cauca",
  "Colombia - Cesar",
  "Colombia - Choco",
  "Colombia - Cordoba",
  "Colombia - Cundinamarca",
  "Colombia - Guainia",
  "Colombia - Guaviare",
  "Colombia - Huila",
  "Colombia - La Guajira",
  "Colombia - Magdalena",
  "Colombia - Meta",
  "Colombia - Narino",
  "Colombia - Norte de Santander",
  "Colombia - Putumayo",
  "Colombia - Quindio",
  "Colombia - Risaralda",
  "Colombia - San Andres y Providencia",
  "Colombia - Santander",
  "Colombia - Sucre",
  "Colombia - Tolima",
  "Colombia - Valle del Cauca",
  "Colombia - Vaupes",
  "Colombia - Vichada",
  "Comoros",
  "Congo (Brazzaville)",
  "Congo (Kinshasa)",
  "Costa Rica",
  "Cote d'Ivoire",
  "Croatia",
  "Cuba",
  "Cyprus",
  "Czechia",
  "Denmark",
  "Diamond Princess",
  "Djibouti",
  "Dominican Republic",
  "Ecuador",
  "Egypt",
  "El Salvador",
  "Equatorial Guinea",
  "Estonia",
  "Eswatini",
  "Ethiopia",
  "Fiji",
  "Finland",
  "France - French Guiana",
  "France - French Polynesia",
  "France - Guadeloupe",
  "France - Martinique",
  "France - Mayotte",
  "France - Reunion",
  "France - Saint Barthelemy",
  "France - St Martin",
  "France",
  "Gabon",
  "Gambia",
  "Georgia",
  "Germany - Baden-Wurttemberg",
  "Germany - Bayern",
  "Germany - Berlin",
  "Germany - Brandenburg",
  "Germany - Bremen",
  "Germany - Hamburg",
  "Germany - Hessen",
  "Germany - Mecklenburg-Vorpommern",
  "Germany - Niedersachsen",
  "Germany - Nordrhein-Westfalen",
  "Germany - Rheinland-Pfalz",
  "Germany - Saarland",
  "Germany - Sachsen",
  "Germany - Sachsen-Anhalt",
  "Germany - Schleswig-Holstein",
  "Germany - Thuringen",
  "Ghana",
  "Greece",
  "Guatemala",
  "Guinea",
  "Guinea-Bissau",
  "Guyana",
  "Haiti",
  "Honduras",
  "Hungary",
  "Iceland",
  "India - Andaman and Nicobar Islands",
  "India - Andhra Pradesh",
  "India - Arunachal Pradesh",
  "India - Assam",
  "India - Bihar",
  "India - Chandigarh",
  "India - Chhattisgarh",
  "India - Dadra and Nagar Haveli and Daman and Diu",
  "India - Delhi",
  "India - Goa",
  "India - Gujarat",
  "India - Haryana",
  "India - Himachal Pradesh",
  "India - Jammu and Kashmir",
  "India - Jharkhand",
  "India - Karnataka",
  "India - Kerala",
  "India - Ladakh",
  "India - Madhya Pradesh",
  "India - Maharashtra",
  "India - Manipur",
  "India - Meghalaya",
  "India - Mizoram",
  "India - Nagaland",
  "India - Odisha",
  "India - Puducherry",
  "India - Punjab",
  "India - Rajasthan",
  "India - Sikkim",
  "India - Tamil Nadu",
  "India - Telangana",
  "India - Tripura",
  "India - Uttar Pradesh",
  "India - Uttarakhand",
  "India - West Bengal",
  "Indonesia",
  "Iran",
  "Iraq",
  "Ireland",
  "Israel",
  "Italy - Abruzzo",
  "Italy - Basilicata",
  "Italy - Calabria",
  "Italy - Campania",
  "Italy - Emilia-Romagna",
  "Italy - Friuli Venezia Giulia",
  "Italy - Lazio",
  "Italy - Liguria",
  "Italy - Lombardia",
  "Italy - Marche",
  "Italy - Molise",
  "Italy - P.A. Bolzano",
  "Italy - P.A. Trento",
  "Italy - Piemonte",
  "Italy - Puglia",
  "Italy - Sardegna",
  "Italy - Sicilia",
  "Italy - Toscana",
  "Italy - Umbria",
  "Italy - Valle d'Aosta",
  "Italy - Veneto",
  "Jamaica",
  "Japan - Aichi",
  "Japan - Akita",
  "Japan - Aomori",
  "Japan - Chiba",
  "Japan - Ehime",
  "Japan - Fukui",
  "Japan - Fukuoka",
  "Japan - Fukushima",
  "Japan - Gifu",
  "Japan - Gunma",
  "Japan - Hiroshima",
  "Japan - Hokkaido",
  "Japan - Hyogo",
  "Japan - Ibaraki",
  "Japan - Ishikawa",
  "Japan - Iwate",
  "Japan - Kagawa",
  "Japan - Kagoshima",
  "Japan - Kanagawa",
  "Japan - Kochi",
  "Japan - Kumamoto",
  "Japan - Kyoto",
  "Japan - Mie",
  "Japan - Miyagi",
  "Japan - Miyazaki",
  "Japan - Nagano",
  "Japan - Nagasaki",
  "Japan - Nara",
  "Japan - Niigata",
  "Japan - Oita",
  "Japan - Okayama",
  "Japan - Okinawa",
  "Japan - Osaka",
  "Japan - Port Quarantine",
  "Japan - Saga",
  "Japan - Saitama",
  "Japan - Shiga",
  "Japan - Shizuoka",
  "Japan - Tochigi",
  "Japan - Tokushima",
  "Japan - Tokyo",
  "Japan - Toyama",
  "Japan - Wakayama",
  "Japan - Yamagata",
  "Japan - Yamaguchi",
  "Japan - Yamanashi",
  "Jordan",
  "Kazakhstan",
  "Kenya",
  "Korea, South",
  "Kosovo",
  "Kuwait",
  "Kyrgyzstan",
  "Latvia",
  "Lebanon",
  "Lesotho",
  "Liberia",
  "Libya",
  "Liechtenstein",
  "Lithuania",
  "Luxembourg",
  "Madagascar",
  "Malawi",
  "Malaysia",
  "Maldives",
  "Mali",
  "Malta",
  "Mauritania",
  "Mauritius",
  "Mexico - Aguascalientes",
  "Mexico - Baja California",
  "Mexico - Baja California Sur",
  "Mexico - Campeche",
  "Mexico - Chiapas",
  "Mexico - Chihuahua",
  "Mexico - Ciudad de Mexico",
  "Mexico - Coahuila",
  "Mexico - Colima",
  "Mexico - Durango",
  "Mexico - Guanajuato",
  "Mexico - Guerrero",
  "Mexico - Hidalgo",
  "Mexico - Jalisco",
  "Mexico - Mexico",
  "Mexico - Michoacan",
  "Mexico - Morelos",
  "Mexico - Nayarit",
  "Mexico - Nuevo Leon",
  "Mexico - Oaxaca",
  "Mexico - Puebla",
  "Mexico - Queretaro",
  "Mexico - Quintana Roo",
  "Mexico - San Luis Potosi",
  "Mexico - Sinaloa",
  "Mexico - Sonora",
  "Mexico - Tabasco",
  "Mexico - Tamaulipas",
  "Mexico - Tlaxcala",
  "Mexico - Veracruz",
  "Mexico - Yucatan",
  "Mexico - Zacatecas",
  "Moldova",
  "Monaco",
  "Montenegro",
  "Morocco",
  "Mozambique",
  "Namibia",
  "Nepal",
  "Netherlands - Aruba",
  "Netherlands - Bonaire, Sint Eustatius and Saba",
  "Netherlands - Curacao",
  "Netherlands - Drenthe",
  "Netherlands - Flevoland",
  "Netherlands - Friesland",
  "Netherlands - Gelderland",
  "Netherlands - Groningen",
  "Netherlands - Limburg",
  "Netherlands - Noord-Brabant",
  "Netherlands - Noord-Holland",
  "Netherlands - Overijssel",
  "Netherlands - Sint Maarten",
  "Netherlands - Unknown",
  "Netherlands - Utrecht",
  "Netherlands - Zeeland",
  "Netherlands - Zuid-Holland",
  "New Zealand",
  "Nicaragua",
  "Niger",
  "Nigeria",
  "North Macedonia",
  "Norway",
  "Oman",
  "Pakistan - Azad Jammu and Kashmir",
  "Pakistan - Balochistan",
  "Pakistan - Gilgit-Baltistan",
  "Pakistan - Islamabad",
  "Pakistan - Khyber Pakhtunkhwa",
  "Pakistan - Punjab",
  "Pakistan - Sindh",
  "Panama",
  "Papua New Guinea",
  "Paraguay",
  "Peru - Amazonas",
  "Peru - Ancash",
  "Peru - Apurimac",
  "Peru - Arequipa",
  "Peru - Ayacucho",
  "Peru - Cajamarca",
  "Peru - Callao",
  "Peru - Cusco",
  "Peru - Huancavelica",
  "Peru - Huanuco",
  "Peru - Ica",
  "Peru - Junin",
  "Peru - La Libertad",
  "Peru - Lambayeque",
  "Peru - Lima",
  "Peru - Loreto",
  "Peru - Madre de Dios",
  "Peru - Moquegua",
  "Peru - Pasco",
  "Peru - Piura",
  "Peru - Puno",
  "Peru - San Martin",
  "Peru - Tacna",
  "Peru - Tumbes",
  "Peru - Ucayali",
  "Philippines",
  "Poland",
  "Portugal",
  "Qatar",
  "Romania",
  "Russia - Adygea Republic",
  "Russia - Altai Krai",
  "Russia - Altai Republic",
  "Russia - Amur Oblast",
  "Russia - Arkhangelsk Oblast",
  "Russia - Astrakhan Oblast",
  "Russia - Bashkortostan Republic",
  "Russia - Belgorod Oblast",
  "Russia - Bryansk Oblast",
  "Russia - Buryatia Republic",
  "Russia - Chechen Republic",
  "Russia - Chelyabinsk Oblast",
  "Russia - Chukotka Autonomous Okrug",
  "Russia - Chuvashia Republic",
  "Russia - Dagestan Republic",
  "Russia - Ingushetia Republic",
  "Russia - Irkutsk Oblast",
  "Russia - Ivanovo Oblast",
  "Russia - Jewish Autonomous Okrug",
  "Russia - Kabardino-Balkarian Republic",
  "Russia - Kaliningrad Oblast",
  "Russia - Kalmykia Republic",
  "Russia - Kaluga Oblast",
  "Russia - Kamchatka Krai",
  "Russia - Karachay-Cherkess Republic",
  "Russia - Karelia Republic",
  "Russia - Kemerovo Oblast",
  "Russia - Khabarovsk Krai",
  "Russia - Khakassia Republic",
  "Russia - Khanty-Mansi Autonomous Okrug",
  "Russia - Kirov Oblast",
  "Russia - Komi Republic",
  "Russia - Kostroma Oblast",
  "Russia - Krasnodar Krai",
  "Russia - Krasnoyarsk Krai",
  "Russia - Kurgan Oblast",
  "Russia - Kursk Oblast",
  "Russia - Leningrad Oblast",
  "Russia - Lipetsk Oblast",
  "Russia - Magadan Oblast",
  "Russia - Mari El Republic",
  "Russia - Mordovia Republic",
  "Russia - Moscow",
  "Russia - Moscow Oblast",
  "Russia - Murmansk Oblast",
  "Russia - Nizhny Novgorod Oblast",
  "Russia - North Ossetia - Alania Republic",
  "Russia - Novgorod Oblast",
  "Russia - Novosibirsk Oblast",
  "Russia - Omsk Oblast",
  "Russia - Orel Oblast",
  "Russia - Orenburg Oblast",
  "Russia - Penza Oblast",
  "Russia - Perm Krai",
  "Russia - Primorsky Krai",
  "Russia - Pskov Oblast",
  "Russia - Rostov Oblast",
  "Russia - Ryazan Oblast",
  "Russia - Saint Petersburg",
  "Russia - Sakha (Yakutiya) Republic",
  "Russia - Sakhalin Oblast",
  "Russia - Samara Oblast",
  "Russia - Saratov Oblast",
  "Russia - Smolensk Oblast",
  "Russia - Stavropol Krai",
  "Russia - Sverdlovsk Oblast",
  "Russia - Tambov Oblast",
  "Russia - Tatarstan Republic",
  "Russia - Tomsk Oblast",
  "Russia - Tula Oblast",
  "Russia - Tver Oblast",
  "Russia - Tyumen Oblast",
  "Russia - Tyva Republic",
  "Russia - Udmurt Republic",
  "Russia - Ulyanovsk Oblast",
  "Russia - Vladimir Oblast",
  "Russia - Volgograd Oblast",
  "Russia - Vologda Oblast",
  "Russia - Voronezh Oblast",
  "Russia - Yamalo-Nenets Autonomous Okrug",
  "Russia - Yaroslavl Oblast",
  "Russia - Zabaykalsky Krai",
  "Rwanda",
  "Saint Lucia",
  "San Marino",
  "Sao Tome and Principe",
  "Saudi Arabia",
  "Senegal",
  "Serbia",
  "Sierra Leone",
  "Singapore",
  "Slovakia",
  "Slovenia",
  "Somalia",
  "South Africa",
  "South Sudan",
  "Spain - Andalusia",
  "Spain - Aragon",
  "Spain - Asturias",
  "Spain - Baleares",
  "Spain - C. Valenciana",
  "Spain - Canarias",
  "Spain - Cantabria",
  "Spain - Castilla - La Mancha",
  "Spain - Castilla y Leon",
  "Spain - Catalonia",
  "Spain - Ceuta",
  "Spain - Extremadura",
  "Spain - Galicia",
  "Spain - La Rioja",
  "Spain - Madrid",
  "Spain - Melilla",
  "Spain - Murcia",
  "Spain - Navarra",
  "Spain - Pais Vasco",
  "Sri Lanka",
  "Sudan",
  "Suriname",
  "Sweden - Blekinge",
  "Sweden - Dalarna",
  "Sweden - Gavleborg",
  "Sweden - Gotland",
  "Sweden - Halland",
  "Sweden - Jamtland Harjedalen",
  "Sweden - Jonkoping",
  "Sweden - Kalmar",
  "Sweden - Kronoberg",
  "Sweden - Norrbotten",
  "Sweden - Orebro",
  "Sweden - Ostergotland",
  "Sweden - Skane",
  "Sweden - Sormland",
  "Sweden - Stockholm",
  "Sweden - Uppsala",
  "Sweden - Varmland",
  "Sweden - Vasterbotten",
  "Sweden - Vasternorrland",
  "Sweden - Vastmanland",
  "Sweden - Vastra Gotaland",
  "Switzerland",
  "Syria",
  "Taiwan*",
  "Tajikistan",
  "Tanzania",
  "Thailand",
  "Togo",
  "Trinidad and Tobago",
  "Tunisia",
  "Turkey",
  "US - Alabama - Autauga",
  "US - Alabama - Baldwin",
  "US - Alabama - Barbour",
  "US - Alabama - Bibb",
  "US - Alabama - Blount",
  "US - Alabama - Bullock",
  "US - Alabama - Butler",
  "US - Alabama - Calhoun",
  "US - Alabama - Chambers",
  "US - Alabama - Cherokee",
  "US - Alabama - Chilton",
  "US - Alabama - Choctaw",
  "US - Alabama - Clarke",
  "US - Alabama - Clay",
  "US - Alabama - Cleburne",
  "US - Alabama - Coffee",
  "US - Alabama - Colbert",
  "US - Alabama - Conecuh",
  "US - Alabama - Coosa",
  "US - Alabama - Covington",
  "US - Alabama - Crenshaw",
  "US - Alabama - Cullman",
  "US - Alabama - Dale",
  "US - Alabama - Dallas",
  "US - Alabama - DeKalb",
  "US - Alabama - Elmore",
  "US - Alabama - Escambia",
  "US - Alabama - Etowah",
  "US - Alabama - Fayette",
  "US - Alabama - Franklin",
  "US - Alabama - Geneva",
  "US - Alabama - Greene",
  "US - Alabama - Hale",
  "US - Alabama - Henry",
  "US - Alabama - Houston",
  "US - Alabama - Jackson",
  "US - Alabama - Jefferson",
  "US - Alabama - Lamar",
  "US - Alabama - Lauderdale",
  "US - Alabama - Lawrence",
  "US - Alabama - Lee",
  "US - Alabama - Limestone",
  "US - Alabama - Lowndes",
  "US - Alabama - Macon",
  "US - Alabama - Madison",
  "US - Alabama - Marengo",
  "US - Alabama - Marion",
  "US - Alabama - Marshall",
  "US - Alabama - Mobile",
  "US - Alabama - Monroe",
  "US - Alabama - Montgomery",
  "US - Alabama - Morgan",
  "US - Alabama - Perry",
  "US - Alabama - Pickens",
  "US - Alabama - Pike",
  "US - Alabama - Randolph",
  "US - Alabama - Russell",
  "US - Alabama - Shelby",
  "US - Alabama - St. Clair",
  "US - Alabama - Sumter",
  "US - Alabama - Talladega",
  "US - Alabama - Tallapoosa",
  "US - Alabama - Tuscaloosa",
  "US - Alabama - Walker",
  "US - Alabama - Washington",
  "US - Alabama - Wilcox",
  "US - Alabama - Winston",
  "US - Alaska - Anchorage",
  "US - Alaska - Bethel",
  "US - Alaska - Dillingham",
  "US - Alaska - Fairbanks North Star",
  "US - Alaska - Juneau",
  "US - Alaska - Kenai Peninsula",
  "US - Alaska - Kodiak Island",
  "US - Alaska - Kusilvak",
  "US - Alaska - Matanuska-Susitna",
  "US - Alaska - North Slope",
  "US - Alaska - Petersburg",
  "US - Alaska - Prince of Wales-Hyder",
  "US - Alaska - Southeast Fairbanks",
  "US - Alaska - Valdez-Cordova",
  "US - Alaska - Yakutat",
  "US - Alaska - Yukon-Koyukuk",
  "US - Arizona - Apache",
  "US - Arizona - Cochise",
  "US - Arizona - Coconino",
  "US - Arizona - Gila",
  "US - Arizona - Graham",
  "US - Arizona - Greenlee",
  "US - Arizona - La Paz",
  "US - Arizona - Maricopa",
  "US - Arizona - Mohave",
  "US - Arizona - Navajo",
  "US - Arizona - Pima",
  "US - Arizona - Pinal",
  "US - Arizona - Santa Cruz",
  "US - Arizona - Yavapai",
  "US - Arizona - Yuma",
  "US - Arkansas - Arkansas",
  "US - Arkansas - Ashley",
  "US - Arkansas - Baxter",
  "US - Arkansas - Benton",
  "US - Arkansas - Boone",
  "US - Arkansas - Bradley",
  "US - Arkansas - Calhoun",
  "US - Arkansas - Carroll",
  "US - Arkansas - Chicot",
  "US - Arkansas - Clark",
  "US - Arkansas - Clay",
  "US - Arkansas - Cleburne",
  "US - Arkansas - Cleveland",
  "US - Arkansas - Columbia",
  "US - Arkansas - Conway",
  "US - Arkansas - Craighead",
  "US - Arkansas - Crawford",
  "US - Arkansas - Crittenden",
  "US - Arkansas - Cross",
  "US - Arkansas - Dallas",
  "US - Arkansas - Desha",
  "US - Arkansas - Drew",
  "US - Arkansas - Faulkner",
  "US - Arkansas - Franklin",
  "US - Arkansas - Fulton",
  "US - Arkansas - Garland",
  "US - Arkansas - Grant",
  "US - Arkansas - Greene",
  "US - Arkansas - Hempstead",
  "US - Arkansas - Hot Spring",
  "US - Arkansas - Howard",
  "US - Arkansas - Independence",
  "US - Arkansas - Izard",
  "US - Arkansas - Jackson",
  "US - Arkansas - Jefferson",
  "US - Arkansas - Johnson",
  "US - Arkansas - Lafayette",
  "US - Arkansas - Lawrence",
  "US - Arkansas - Lee",
  "US - Arkansas - Lincoln",
  "US - Arkansas - Little River",
  "US - Arkansas - Logan",
  "US - Arkansas - Lonoke",
  "US - Arkansas - Madison",
  "US - Arkansas - Marion",
  "US - Arkansas - Miller",
  "US - Arkansas - Mississippi",
  "US - Arkansas - Monroe",
  "US - Arkansas - Montgomery",
  "US - Arkansas - Nevada",
  "US - Arkansas - Newton",
  "US - Arkansas - Ouachita",
  "US - Arkansas - Perry",
  "US - Arkansas - Phillips",
  "US - Arkansas - Pike",
  "US - Arkansas - Poinsett",
  "US - Arkansas - Polk",
  "US - Arkansas - Pope",
  "US - Arkansas - Prairie",
  "US - Arkansas - Pulaski",
  "US - Arkansas - Randolph",
  "US - Arkansas - Saline",
  "US - Arkansas - Scott",
  "US - Arkansas - Searcy",
  "US - Arkansas - Sebastian",
  "US - Arkansas - Sevier",
  "US - Arkansas - Sharp",
  "US - Arkansas - St. Francis",
  "US - Arkansas - Stone",
  "US - Arkansas - Union",
  "US - Arkansas - Van Buren",
  "US - Arkansas - Washington",
  "US - Arkansas - White",
  "US - Arkansas - Woodruff",
  "US - Arkansas - Yell",
  "US - California - Alameda",
  "US - California - Amador",
  "US - California - Butte",
  "US - California - Calaveras",
  "US - California - Colusa",
  "US - California - Contra Costa",
  "US - California - Del Norte",
  "US - California - El Dorado",
  "US - California - Fresno",
  "US - California - Glenn",
  "US - California - Humboldt",
  "US - California - Imperial",
  "US - California - Inyo",
  "US - California - Kern",
  "US - California - Kings",
  "US - California - Lake",
  "US - California - Lassen",
  "US - California - Los Angeles",
  "US - California - Madera",
  "US - California - Marin",
  "US - California - Mariposa",
  "US - California - Mendocino",
  "US - California - Merced",
  "US - California - Mono",
  "US - California - Monterey",
  "US - California - Napa",
  "US - California - Nevada",
  "US - California - Orange",
  "US - California - Placer",
  "US - California - Plumas",
  "US - California - Riverside",
  "US - California - Sacramento",
  "US - California - San Benito",
  "US - California - San Bernardino",
  "US - California - San Diego",
  "US - California - San Francisco",
  "US - California - San Joaquin",
  "US - California - San Luis Obispo",
  "US - California - San Mateo",
  "US - California - Santa Barbara",
  "US - California - Santa Clara",
  "US - California - Santa Cruz",
  "US - California - Shasta",
  "US - California - Siskiyou",
  "US - California - Solano",
  "US - California - Sonoma",
  "US - California - Stanislaus",
  "US - California - Sutter",
  "US - California - Tehama",
  "US - California - Trinity",
  "US - California - Tulare",
  "US - California - Tuolumne",
  "US - California - Ventura",
  "US - California - Yolo",
  "US - California - Yuba",
  "US - Colorado - Adams",
  "US - Colorado - Alamosa",
  "US - Colorado - Arapahoe",
  "US - Colorado - Bent",
  "US - Colorado - Boulder",
  "US - Colorado - Broomfield",
  "US - Colorado - Chaffee",
  "US - Colorado - Cheyenne",
  "US - Colorado - Clear Creek",
  "US - Colorado - Conejos",
  "US - Colorado - Costilla",
  "US - Colorado - Crowley",
  "US - Colorado - Delta",
  "US - Colorado - Denver",
  "US - Colorado - Douglas",
  "US - Colorado - Eagle",
  "US - Colorado - El Paso",
  "US - Colorado - Elbert",
  "US - Colorado - Fremont",
  "US - Colorado - Garfield",
  "US - Colorado - Gilpin",
  "US - Colorado - Grand",
  "US - Colorado - Gunnison",
  "US - Colorado - Huerfano",
  "US - Colorado - Jefferson",
  "US - Colorado - Kiowa",
  "US - Colorado - Kit Carson",
  "US - Colorado - La Plata",
  "US - Colorado - Larimer",
  "US - Colorado - Las Animas",
  "US - Colorado - Lincoln",
  "US - Colorado - Logan",
  "US - Colorado - Mesa",
  "US - Colorado - Mineral",
  "US - Colorado - Moffat",
  "US - Colorado - Montezuma",
  "US - Colorado - Montrose",
  "US - Colorado - Morgan",
  "US - Colorado - Otero",
  "US - Colorado - Ouray",
  "US - Colorado - Park",
  "US - Colorado - Phillips",
  "US - Colorado - Pitkin",
  "US - Colorado - Prowers",
  "US - Colorado - Pueblo",
  "US - Colorado - Rio Blanco",
  "US - Colorado - Rio Grande",
  "US - Colorado - Routt",
  "US - Colorado - Saguache",
  "US - Colorado - Sedgwick",
  "US - Colorado - Summit",
  "US - Colorado - Teller",
  "US - Colorado - Washington",
  "US - Colorado - Weld",
  "US - Colorado - Yuma",
  "US - Connecticut - Fairfield",
  "US - Connecticut - Hartford",
  "US - Connecticut - Litchfield",
  "US - Connecticut - Middlesex",
  "US - Connecticut - New Haven",
  "US - Connecticut - New London",
  "US - Connecticut - Tolland",
  "US - Connecticut - Windham",
  "US - Delaware - Kent",
  "US - Delaware - New Castle",
  "US - Delaware - Sussex",
  "US - District of Columbia - District of Columbia",
  "US - Florida - Alachua",
  "US - Florida - Baker",
  "US - Florida - Bay",
  "US - Florida - Bradford",
  "US - Florida - Brevard",
  "US - Florida - Broward",
  "US - Florida - Calhoun",
  "US - Florida - Charlotte",
  "US - Florida - Citrus",
  "US - Florida - Clay",
  "US - Florida - Collier",
  "US - Florida - Columbia",
  "US - Florida - DeSoto",
  "US - Florida - Dixie",
  "US - Florida - Duval",
  "US - Florida - Escambia",
  "US - Florida - Flagler",
  "US - Florida - Franklin",
  "US - Florida - Gadsden",
  "US - Florida - Gilchrist",
  "US - Florida - Glades",
  "US - Florida - Gulf",
  "US - Florida - Hamilton",
  "US - Florida - Hardee",
  "US - Florida - Hendry",
  "US - Florida - Hernando",
  "US - Florida - Highlands",
  "US - Florida - Hillsborough",
  "US - Florida - Holmes",
  "US - Florida - Indian River",
  "US - Florida - Jackson",
  "US - Florida - Jefferson",
  "US - Florida - Lafayette",
  "US - Florida - Lake",
  "US - Florida - Lee",
  "US - Florida - Leon",
  "US - Florida - Levy",
  "US - Florida - Liberty",
  "US - Florida - Madison",
  "US - Florida - Manatee",
  "US - Florida - Marion",
  "US - Florida - Martin",
  "US - Florida - Miami-Dade",
  "US - Florida - Monroe",
  "US - Florida - Nassau",
  "US - Florida - Okaloosa",
  "US - Florida - Okeechobee",
  "US - Florida - Orange",
  "US - Florida - Osceola",
  "US - Florida - Palm Beach",
  "US - Florida - Pasco",
  "US - Florida - Pinellas",
  "US - Florida - Polk",
  "US - Florida - Putnam",
  "US - Florida - Santa Rosa",
  "US - Florida - Sarasota",
  "US - Florida - Seminole",
  "US - Florida - St. Johns",
  "US - Florida - St. Lucie",
  "US - Florida - Sumter",
  "US - Florida - Suwannee",
  "US - Florida - Taylor",
  "US - Florida - Union",
  "US - Florida - Volusia",
  "US - Florida - Wakulla",
  "US - Florida - Walton",
  "US - Florida - Washington",
  "US - Georgia - Appling",
  "US - Georgia - Atkinson",
  "US - Georgia - Bacon",
  "US - Georgia - Baker",
  "US - Georgia - Baldwin",
  "US - Georgia - Banks",
  "US - Georgia - Barrow",
  "US - Georgia - Bartow",
  "US - Georgia - Ben Hill",
  "US - Georgia - Berrien",
  "US - Georgia - Bibb",
  "US - Georgia - Bleckley",
  "US - Georgia - Brantley",
  "US - Georgia - Brooks",
  "US - Georgia - Bryan",
  "US - Georgia - Bulloch",
  "US - Georgia - Burke",
  "US - Georgia - Butts",
  "US - Georgia - Calhoun",
  "US - Georgia - Camden",
  "US - Georgia - Candler",
  "US - Georgia - Carroll",
  "US - Georgia - Catoosa",
  "US - Georgia - Charlton",
  "US - Georgia - Chatham",
  "US - Georgia - Chattahoochee",
  "US - Georgia - Chattooga",
  "US - Georgia - Cherokee",
  "US - Georgia - Clarke",
  "US - Georgia - Clay",
  "US - Georgia - Clayton",
  "US - Georgia - Clinch",
  "US - Georgia - Cobb",
  "US - Georgia - Coffee",
  "US - Georgia - Colquitt",
  "US - Georgia - Columbia",
  "US - Georgia - Cook",
  "US - Georgia - Coweta",
  "US - Georgia - Crawford",
  "US - Georgia - Crisp",
  "US - Georgia - Dade",
  "US - Georgia - Dawson",
  "US - Georgia - DeKalb",
  "US - Georgia - Decatur",
  "US - Georgia - Dodge",
  "US - Georgia - Dooly",
  "US - Georgia - Dougherty",
  "US - Georgia - Douglas",
  "US - Georgia - Early",
  "US - Georgia - Echols",
  "US - Georgia - Effingham",
  "US - Georgia - Elbert",
  "US - Georgia - Emanuel",
  "US - Georgia - Evans",
  "US - Georgia - Fannin",
  "US - Georgia - Fayette",
  "US - Georgia - Floyd",
  "US - Georgia - Forsyth",
  "US - Georgia - Franklin",
  "US - Georgia - Fulton",
  "US - Georgia - Gilmer",
  "US - Georgia - Glascock",
  "US - Georgia - Glynn",
  "US - Georgia - Gordon",
  "US - Georgia - Grady",
  "US - Georgia - Greene",
  "US - Georgia - Gwinnett",
  "US - Georgia - Habersham",
  "US - Georgia - Hall",
  "US - Georgia - Hancock",
  "US - Georgia - Haralson",
  "US - Georgia - Harris",
  "US - Georgia - Hart",
  "US - Georgia - Heard",
  "US - Georgia - Henry",
  "US - Georgia - Houston",
  "US - Georgia - Irwin",
  "US - Georgia - Jackson",
  "US - Georgia - Jasper",
  "US - Georgia - Jeff Davis",
  "US - Georgia - Jefferson",
  "US - Georgia - Jenkins",
  "US - Georgia - Johnson",
  "US - Georgia - Jones",
  "US - Georgia - Lamar",
  "US - Georgia - Lanier",
  "US - Georgia - Laurens",
  "US - Georgia - Lee",
  "US - Georgia - Liberty",
  "US - Georgia - Lincoln",
  "US - Georgia - Long",
  "US - Georgia - Lowndes",
  "US - Georgia - Lumpkin",
  "US - Georgia - Macon",
  "US - Georgia - Madison",
  "US - Georgia - Marion",
  "US - Georgia - McDuffie",
  "US - Georgia - McIntosh",
  "US - Georgia - Meriwether",
  "US - Georgia - Miller",
  "US - Georgia - Mitchell",
  "US - Georgia - Monroe",
  "US - Georgia - Montgomery",
  "US - Georgia - Morgan",
  "US - Georgia - Murray",
  "US - Georgia - Muscogee",
  "US - Georgia - Newton",
  "US - Georgia - Oconee",
  "US - Georgia - Oglethorpe",
  "US - Georgia - Out of GA",
  "US - Georgia - Paulding",
  "US - Georgia - Peach",
  "US - Georgia - Pickens",
  "US - Georgia - Pierce",
  "US - Georgia - Pike",
  "US - Georgia - Polk",
  "US - Georgia - Pulaski",
  "US - Georgia - Putnam",
  "US - Georgia - Quitman",
  "US - Georgia - Rabun",
  "US - Georgia - Randolph",
  "US - Georgia - Richmond",
  "US - Georgia - Rockdale",
  "US - Georgia - Schley",
  "US - Georgia - Screven",
  "US - Georgia - Seminole",
  "US - Georgia - Spalding",
  "US - Georgia - Stephens",
  "US - Georgia - Stewart",
  "US - Georgia - Sumter",
  "US - Georgia - Talbot",
  "US - Georgia - Tattnall",
  "US - Georgia - Taylor",
  "US - Georgia - Telfair",
  "US - Georgia - Terrell",
  "US - Georgia - Thomas",
  "US - Georgia - Tift",
  "US - Georgia - Toombs",
  "US - Georgia - Towns",
  "US - Georgia - Treutlen",
  "US - Georgia - Troup",
  "US - Georgia - Turner",
  "US - Georgia - Twiggs",
  "US - Georgia - Union",
  "US - Georgia - Upson",
  "US - Georgia - Walker",
  "US - Georgia - Walton",
  "US - Georgia - Ware",
  "US - Georgia - Warren",
  "US - Georgia - Washington",
  "US - Georgia - Wayne",
  "US - Georgia - Webster",
  "US - Georgia - Wheeler",
  "US - Georgia - White",
  "US - Georgia - Whitfield",
  "US - Georgia - Wilcox",
  "US - Georgia - Wilkes",
  "US - Georgia - Wilkinson",
  "US - Georgia - Worth",
  "US - Grand Princess",
  "US - Guam",
  "US - Hawaii - Hawaii",
  "US - Hawaii - Honolulu",
  "US - Hawaii - Kauai",
  "US - Hawaii - Maui",
  "US - Hawaii - Out of HI",
  "US - Idaho - Ada",
  "US - Idaho - Adams",
  "US - Idaho - Bannock",
  "US - Idaho - Bear Lake",
  "US - Idaho - Benewah",
  "US - Idaho - Bingham",
  "US - Idaho - Blaine",
  "US - Idaho - Boise",
  "US - Idaho - Bonner",
  "US - Idaho - Bonneville",
  "US - Idaho - Boundary",
  "US - Idaho - Canyon",
  "US - Idaho - Caribou",
  "US - Idaho - Cassia",
  "US - Idaho - Clearwater",
  "US - Idaho - Custer",
  "US - Idaho - Elmore",
  "US - Idaho - Franklin",
  "US - Idaho - Fremont",
  "US - Idaho - Gem",
  "US - Idaho - Gooding",
  "US - Idaho - Idaho",
  "US - Idaho - Jefferson",
  "US - Idaho - Jerome",
  "US - Idaho - Kootenai",
  "US - Idaho - Latah",
  "US - Idaho - Lemhi",
  "US - Idaho - Lewis",
  "US - Idaho - Lincoln",
  "US - Idaho - Madison",
  "US - Idaho - Minidoka",
  "US - Idaho - Nez Perce",
  "US - Idaho - Oneida",
  "US - Idaho - Owyhee",
  "US - Idaho - Payette",
  "US - Idaho - Power",
  "US - Idaho - Shoshone",
  "US - Idaho - Teton",
  "US - Idaho - Twin Falls",
  "US - Idaho - Valley",
  "US - Idaho - Washington",
  "US - Illinois - Adams",
  "US - Illinois - Alexander",
  "US - Illinois - Bond",
  "US - Illinois - Boone",
  "US - Illinois - Brown",
  "US - Illinois - Bureau",
  "US - Illinois - Calhoun",
  "US - Illinois - Carroll",
  "US - Illinois - Cass",
  "US - Illinois - Champaign",
  "US - Illinois - Christian",
  "US - Illinois - Clark",
  "US - Illinois - Clay",
  "US - Illinois - Clinton",
  "US - Illinois - Coles",
  "US - Illinois - Cook",
  "US - Illinois - Crawford",
  "US - Illinois - Cumberland",
  "US - Illinois - De Witt",
  "US - Illinois - DeKalb",
  "US - Illinois - Douglas",
  "US - Illinois - DuPage",
  "US - Illinois - Edgar",
  "US - Illinois - Edwards",
  "US - Illinois - Effingham",
  "US - Illinois - Fayette",
  "US - Illinois - Ford",
  "US - Illinois - Franklin",
  "US - Illinois - Fulton",
  "US - Illinois - Gallatin",
  "US - Illinois - Greene",
  "US - Illinois - Grundy",
  "US - Illinois - Hamilton",
  "US - Illinois - Hancock",
  "US - Illinois - Hardin",
  "US - Illinois - Henderson",
  "US - Illinois - Henry",
  "US - Illinois - Iroquois",
  "US - Illinois - Jackson",
  "US - Illinois - Jasper",
  "US - Illinois - Jefferson",
  "US - Illinois - Jersey",
  "US - Illinois - Jo Daviess",
  "US - Illinois - Johnson",
  "US - Illinois - Kane",
  "US - Illinois - Kankakee",
  "US - Illinois - Kendall",
  "US - Illinois - Knox",
  "US - Illinois - LaSalle",
  "US - Illinois - Lake",
  "US - Illinois - Lawrence",
  "US - Illinois - Lee",
  "US - Illinois - Livingston",
  "US - Illinois - Logan",
  "US - Illinois - Macon",
  "US - Illinois - Macoupin",
  "US - Illinois - Madison",
  "US - Illinois - Marion",
  "US - Illinois - Marshall",
  "US - Illinois - Mason",
  "US - Illinois - Massac",
  "US - Illinois - McDonough",
  "US - Illinois - McHenry",
  "US - Illinois - McLean",
  "US - Illinois - Menard",
  "US - Illinois - Mercer",
  "US - Illinois - Monroe",
  "US - Illinois - Montgomery",
  "US - Illinois - Morgan",
  "US - Illinois - Moultrie",
  "US - Illinois - Ogle",
  "US - Illinois - Peoria",
  "US - Illinois - Perry",
  "US - Illinois - Piatt",
  "US - Illinois - Pike",
  "US - Illinois - Pope",
  "US - Illinois - Pulaski",
  "US - Illinois - Randolph",
  "US - Illinois - Richland",
  "US - Illinois - Rock Island",
  "US - Illinois - Saline",
  "US - Illinois - Sangamon",
  "US - Illinois - Schuyler",
  "US - Illinois - Scott",
  "US - Illinois - Shelby",
  "US - Illinois - St. Clair",
  "US - Illinois - Stark",
  "US - Illinois - Stephenson",
  "US - Illinois - Tazewell",
  "US - Illinois - Union",
  "US - Illinois - Vermilion",
  "US - Illinois - Wabash",
  "US - Illinois - Warren",
  "US - Illinois - Washington",
  "US - Illinois - Wayne",
  "US - Illinois - White",
  "US - Illinois - Whiteside",
  "US - Illinois - Will",
  "US - Illinois - Williamson",
  "US - Illinois - Winnebago",
  "US - Illinois - Woodford",
  "US - Indiana - Adams",
  "US - Indiana - Allen",
  "US - Indiana - Bartholomew",
  "US - Indiana - Benton",
  "US - Indiana - Blackford",
  "US - Indiana - Boone",
  "US - Indiana - Brown",
  "US - Indiana - Carroll",
  "US - Indiana - Cass",
  "US - Indiana - Clark",
  "US - Indiana - Clay",
  "US - Indiana - Clinton",
  "US - Indiana - Crawford",
  "US - Indiana - Daviess",
  "US - Indiana - DeKalb",
  "US - Indiana - Dearborn",
  "US - Indiana - Decatur",
  "US - Indiana - Delaware",
  "US - Indiana - Dubois",
  "US - Indiana - Elkhart",
  "US - Indiana - Fayette",
  "US - Indiana - Floyd",
  "US - Indiana - Fountain",
  "US - Indiana - Franklin",
  "US - Indiana - Fulton",
  "US - Indiana - Gibson",
  "US - Indiana - Grant",
  "US - Indiana - Greene",
  "US - Indiana - Hamilton",
  "US - Indiana - Hancock",
  "US - Indiana - Harrison",
  "US - Indiana - Hendricks",
  "US - Indiana - Henry",
  "US - Indiana - Howard",
  "US - Indiana - Huntington",
  "US - Indiana - Jackson",
  "US - Indiana - Jasper",
  "US - Indiana - Jay",
  "US - Indiana - Jefferson",
  "US - Indiana - Jennings",
  "US - Indiana - Johnson",
  "US - Indiana - Knox",
  "US - Indiana - Kosciusko",
  "US - Indiana - LaGrange",
  "US - Indiana - LaPorte",
  "US - Indiana - Lake",
  "US - Indiana - Lawrence",
  "US - Indiana - Madison",
  "US - Indiana - Marion",
  "US - Indiana - Marshall",
  "US - Indiana - Martin",
  "US - Indiana - Miami",
  "US - Indiana - Monroe",
  "US - Indiana - Montgomery",
  "US - Indiana - Morgan",
  "US - Indiana - Newton",
  "US - Indiana - Noble",
  "US - Indiana - Ohio",
  "US - Indiana - Orange",
  "US - Indiana - Owen",
  "US - Indiana - Parke",
  "US - Indiana - Perry",
  "US - Indiana - Pike",
  "US - Indiana - Porter",
  "US - Indiana - Posey",
  "US - Indiana - Pulaski",
  "US - Indiana - Putnam",
  "US - Indiana - Randolph",
  "US - Indiana - Ripley",
  "US - Indiana - Rush",
  "US - Indiana - Scott",
  "US - Indiana - Shelby",
  "US - Indiana - Spencer",
  "US - Indiana - St. Joseph",
  "US - Indiana - Starke",
  "US - Indiana - Steuben",
  "US - Indiana - Sullivan",
  "US - Indiana - Switzerland",
  "US - Indiana - Tippecanoe",
  "US - Indiana - Tipton",
  "US - Indiana - Union",
  "US - Indiana - Vanderburgh",
  "US - Indiana - Vermillion",
  "US - Indiana - Vigo",
  "US - Indiana - Wabash",
  "US - Indiana - Warren",
  "US - Indiana - Warrick",
  "US - Indiana - Washington",
  "US - Indiana - Wayne",
  "US - Indiana - Wells",
  "US - Indiana - White",
  "US - Indiana - Whitley",
  "US - Iowa - Adair",
  "US - Iowa - Adams",
  "US - Iowa - Allamakee",
  "US - Iowa - Appanoose",
  "US - Iowa - Audubon",
  "US - Iowa - Benton",
  "US - Iowa - Black Hawk",
  "US - Iowa - Boone",
  "US - Iowa - Bremer",
  "US - Iowa - Buchanan",
  "US - Iowa - Buena Vista",
  "US - Iowa - Butler",
  "US - Iowa - Calhoun",
  "US - Iowa - Carroll",
  "US - Iowa - Cass",
  "US - Iowa - Cedar",
  "US - Iowa - Cerro Gordo",
  "US - Iowa - Cherokee",
  "US - Iowa - Chickasaw",
  "US - Iowa - Clarke",
  "US - Iowa - Clay",
  "US - Iowa - Clayton",
  "US - Iowa - Clinton",
  "US - Iowa - Crawford",
  "US - Iowa - Dallas",
  "US - Iowa - Davis",
  "US - Iowa - Decatur",
  "US - Iowa - Delaware",
  "US - Iowa - Des Moines",
  "US - Iowa - Dickinson",
  "US - Iowa - Dubuque",
  "US - Iowa - Emmet",
  "US - Iowa - Fayette",
  "US - Iowa - Floyd",
  "US - Iowa - Franklin",
  "US - Iowa - Fremont",
  "US - Iowa - Greene",
  "US - Iowa - Grundy",
  "US - Iowa - Guthrie",
  "US - Iowa - Hamilton",
  "US - Iowa - Hancock",
  "US - Iowa - Hardin",
  "US - Iowa - Harrison",
  "US - Iowa - Henry",
  "US - Iowa - Howard",
  "US - Iowa - Humboldt",
  "US - Iowa - Ida",
  "US - Iowa - Iowa",
  "US - Iowa - Jackson",
  "US - Iowa - Jasper",
  "US - Iowa - Jefferson",
  "US - Iowa - Johnson",
  "US - Iowa - Jones",
  "US - Iowa - Keokuk",
  "US - Iowa - Kossuth",
  "US - Iowa - Lee",
  "US - Iowa - Linn",
  "US - Iowa - Louisa",
  "US - Iowa - Lucas",
  "US - Iowa - Lyon",
  "US - Iowa - Madison",
  "US - Iowa - Mahaska",
  "US - Iowa - Marion",
  "US - Iowa - Marshall",
  "US - Iowa - Mills",
  "US - Iowa - Mitchell",
  "US - Iowa - Monona",
  "US - Iowa - Monroe",
  "US - Iowa - Montgomery",
  "US - Iowa - Muscatine",
  "US - Iowa - O'Brien",
  "US - Iowa - Osceola",
  "US - Iowa - Page",
  "US - Iowa - Palo Alto",
  "US - Iowa - Plymouth",
  "US - Iowa - Pocahontas",
  "US - Iowa - Polk",
  "US - Iowa - Pottawattamie",
  "US - Iowa - Poweshiek",
  "US - Iowa - Ringgold",
  "US - Iowa - Sac",
  "US - Iowa - Scott",
  "US - Iowa - Shelby",
  "US - Iowa - Sioux",
  "US - Iowa - Story",
  "US - Iowa - Tama",
  "US - Iowa - Taylor",
  "US - Iowa - Union",
  "US - Iowa - Van Buren",
  "US - Iowa - Wapello",
  "US - Iowa - Warren",
  "US - Iowa - Washington",
  "US - Iowa - Wayne",
  "US - Iowa - Webster",
  "US - Iowa - Winnebago",
  "US - Iowa - Winneshiek",
  "US - Iowa - Woodbury",
  "US - Iowa - Worth",
  "US - Iowa - Wright",
  "US - Kansas - Allen",
  "US - Kansas - Anderson",
  "US - Kansas - Atchison",
  "US - Kansas - Barber",
  "US - Kansas - Barton",
  "US - Kansas - Bourbon",
  "US - Kansas - Brown",
  "US - Kansas - Butler",
  "US - Kansas - Chase",
  "US - Kansas - Chautauqua",
  "US - Kansas - Cherokee",
  "US - Kansas - Cheyenne",
  "US - Kansas - Clark",
  "US - Kansas - Clay",
  "US - Kansas - Cloud",
  "US - Kansas - Coffey",
  "US - Kansas - Comanche",
  "US - Kansas - Cowley",
  "US - Kansas - Crawford",
  "US - Kansas - Decatur",
  "US - Kansas - Dickinson",
  "US - Kansas - Doniphan",
  "US - Kansas - Douglas",
  "US - Kansas - Edwards",
  "US - Kansas - Ellis",
  "US - Kansas - Ellsworth",
  "US - Kansas - Finney",
  "US - Kansas - Ford",
  "US - Kansas - Franklin",
  "US - Kansas - Geary",
  "US - Kansas - Gove",
  "US - Kansas - Graham",
  "US - Kansas - Grant",
  "US - Kansas - Gray",
  "US - Kansas - Greeley",
  "US - Kansas - Greenwood",
  "US - Kansas - Harper",
  "US - Kansas - Harvey",
  "US - Kansas - Haskell",
  "US - Kansas - Hodgeman",
  "US - Kansas - Jackson",
  "US - Kansas - Jefferson",
  "US - Kansas - Jewell",
  "US - Kansas - Johnson",
  "US - Kansas - Kearny",
  "US - Kansas - Kingman",
  "US - Kansas - Kiowa",
  "US - Kansas - Labette",
  "US -  Kansas - Lane",
  "US - Kansas - Leavenworth",
  "US - Kansas - Lincoln",
  "US - Kansas - Linn",
  "US - Kansas - Logan",
  "US - Kansas - Lyon",
  "US - Kansas - Marion",
  "US - Kansas - Marshall",
  "US - Kansas - McPherson",
  "US - Kansas - Meade",
  "US  - Kansas - Miami",
  "US - Kansas - Mitchell",
  "US - Kansas - Montgomery",
  "US - Kansas - Morris",
  "US - Kansas - Morton",
  "US - Kansas - Nemaha",
  "US - Kansas - Neosho",
  "US - Kansas - Ness",
  "US - Kansas - Norton",
  "US - Kansas - Osage",
  "US - Kansas - Osborne",
  "US - Kansas - Ottawa",
  "US - Kansas - Pawnee",
  "US - Kansas - Phillips",
  "US - Kansas - Pottawatomie",
  "US - Kansas - Pratt",
  "US - Kansas - Rawlins",
  "US - Kansas - Reno",
  "US - Kansas - Republic",
  "US - Kansas - Rice",
  "US - Kansas - Riley",
  "US - Kansas - Rooks",
  "US - Kansas - Rush",
  "US - Kansas - Russell",
  "US - Kansas - Saline",
  "US - Kansas - Scott",
  "US - Kansas - Sedgwick",
  "US - Kansas - Seward",
  "US - Kansas - Shawnee",
  "US - Kansas - Sheridan",
  "US - Kansas - Sherman",
  "US - Kansas - Smith",
  "US - Kansas - Stafford",
  "US - Kansas - Stanton",
  "US - Kansas - Stevens",
  "US - Kansas - Sumner",
  "US - Kansas - Thomas",
  "US - Kansas - Trego",
  "US - Kansas - Wabaunsee",
  "US - Kansas - Wallace",
  "US - Kansas - Washington",
  "US - Kansas - Wichita",
  "US - Kansas - Wilson",
  "US - Kansas - Woodson",
  "US - Kansas - Wyandotte",
  "US - Kentucky - Adair",
  "US - Kentucky - Allen",
  "US - Kentucky - Anderson",
  "US - Kentucky - Ballard",
  "US - Kentucky - Barren",
  "US - Kentucky - Bath",
  "US - Kentucky - Bell",
  "US - Kentucky - Boone",
  "US - Kentucky - Bourbon",
  "US - Kentucky - Boyd",
  "US - Kentucky - Bracken",
  "US - Kentucky - Breathitt",
  "US - Kentucky - Breckinridge",
  "US - Kentucky - Bullitt",
  "US - Kentucky - Butler",
  "US - Kentucky - Caldwell",
  "US - Kentucky - Calloway",
  "US - Kentucky - Campbell",
  "US - Kentucky - Carlisle",
  "US - Kentucky - Carroll",
  "US - Kentucky - Carter",
  "US - Kentucky - Casey",
  "US - Kentucky - Christian",
  "US - Kentucky - Clark",
  "US - Kentucky - Clay",
  "US - Kentucky - Clinton",
  "US - Kentucky - Crittenden",
  "US - Kentucky - Cumberland",
  "US - Kentucky - Daviess",
  "US - Kentucky - Edmonson",
  "US - Kentucky - Elliott",
  "US - Kentucky - Fayette",
  "US - Kentucky - Fleming",
  "US - Kentucky - Floyd",
  "US - Kentucky - Franklin",
  "US - Kentucky - Fulton",
  "US - Kentucky - Gallatin",
  "US - Kentucky - Garrard",
  "US - Kentucky - Grant",
  "US - Kentucky - Graves",
  "US - Kentucky - Grayson",
  "US - Kentucky - Green",
  "US - Kentucky - Greenup",
  "US - Kentucky - Hancock",
  "US - Kentucky - Hardin",
  "US - Kentucky - Harlan",
  "US - Kentucky - Harrison",
  "US - Kentucky - Hart",
  "US - Kentucky - Henderson",
  "US - Kentucky - Henry",
  "US - Kentucky - Hickman",
  "US - Kentucky - Hopkins",
  "US - Kentucky - Jackson",
  "US - Kentucky - Jefferson",
  "US - Kentucky - Jessamine",
  "US - Kentucky - Johnson",
  "US - Kentucky - Kenton",
  "US - Kentucky - Knott",
  "US - Kentucky - Knox",
  "US - Kentucky - Larue",
  "US - Kentucky - Laurel",
  "US - Kentucky - Lawrence",
  "US - Kentucky - Lee",
  "US - Kentucky - Leslie",
  "US - Kentucky - Letcher",
  "US - Kentucky - Lewis",
  "US - Kentucky - Lincoln",
  "US - Kentucky - Livingston",
  "US - Kentucky - Logan",
  "US - Kentucky - Lyon",
  "US - Kentucky - Madison",
  "US - Kentucky - Magoffin",
  "US - Kentucky - Marion",
  "US - Kentucky - Marshall",
  "US - Kentucky - Martin",
  "US - Kentucky - Mason",
  "US - Kentucky - McCracken",
  "US - Kentucky - McCreary",
  "US - Kentucky - McLean",
  "US - Kentucky - Meade",
  "US - Kentucky - Menifee",
  "US - Kentucky - Mercer",
  "US - Kentucky - Metcalfe",
  "US - Kentucky - Monroe",
  "US - Kentucky - Montgomery",
  "US - Kentucky - Muhlenberg",
  "US - Kentucky - Nelson",
  "US - Kentucky - Nicholas",
  "US - Kentucky - Ohio",
  "US - Kentucky - Oldham",
  "US - Kentucky - Owen",
  "US - Kentucky - Owsley",
  "US - Kentucky - Pendleton",
  "US - Kentucky - Perry",
  "US - Kentucky - Pike",
  "US - Kentucky - Pulaski",
  "US - Kentucky - Robertson",
  "US - Kentucky - Rockcastle",
  "US - Kentucky - Rowan",
  "US - Kentucky - Russell",
  "US - Kentucky - Scott",
  "US - Kentucky - Shelby",
  "US - Kentucky - Simpson",
  "US - Kentucky - Spencer",
  "US - Kentucky - Taylor",
  "US - Kentucky - Todd",
  "US - Kentucky - Trigg",
  "US - Kentucky - Union",
  "US - Kentucky - Warren",
  "US - Kentucky - Washington",
  "US - Kentucky - Wayne",
  "US - Kentucky - Webster",
  "US - Kentucky - Whitley",
  "US - Kentucky - Wolfe",
  "US - Kentucky - Woodford",
  "US - Louisiana - Acadia",
  "US - Louisiana - Allen",
  "US - Louisiana - Ascension",
  "US - Louisiana - Assumption",
  "US - Louisiana - Avoyelles",
  "US - Louisiana - Beauregard",
  "US - Louisiana - Bienville",
  "US - Louisiana - Bossier",
  "US - Louisiana - Caddo",
  "US - Louisiana - Calcasieu",
  "US - Louisiana - Caldwell",
  "US - Louisiana - Cameron",
  "US - Louisiana - Catahoula",
  "US - Louisiana - Claiborne",
  "US - Louisiana - Concordia",
  "US - Louisiana - De Soto",
  "US - Louisiana - East Baton Rouge",
  "US - Louisiana - East Carroll",
  "US - Louisiana - East Feliciana",
  "US - Louisiana - Evangeline",
  "US - Louisiana - Franklin",
  "US - Louisiana - Grant",
  "US - Louisiana - Iberia",
  "US - Louisiana - Iberville",
  "US - Louisiana - Jackson",
  "US - Louisiana - Jefferson",
  "US - Louisiana - Jefferson Davis",
  "US - Louisiana - LaSalle",
  "US - Louisiana - Lafayette",
  "US - Louisiana - Lafourche",
  "US - Louisiana - Lincoln",
  "US - Louisiana - Livingston",
  "US - Louisiana - Madison",
  "US - Louisiana - Morehouse",
  "US - Louisiana - Natchitoches",
  "US - Louisiana - Orleans",
  "US - Louisiana - Ouachita",
  "US - Louisiana - Plaquemines",
  "US - Louisiana - Pointe Coupee",
  "US - Louisiana - Rapides",
  "US - Louisiana - Red River",
  "US - Louisiana - Richland",
  "US - Louisiana - Sabine",
  "US - Louisiana - St. Bernard",
  "US - Louisiana - St. Charles",
  "US - Louisiana - St. Helena",
  "US - Louisiana - St. James",
  "US - Louisiana - St. John the Baptist",
  "US - Louisiana - St. Landry",
  "US - Louisiana - St. Martin",
  "US - Louisiana - St. Mary",
  "US - Louisiana - St. Tammany",
  "US - Louisiana - Tangipahoa",
  "US - Louisiana - Tensas",
  "US - Louisiana - Terrebonne",
  "US - Louisiana - Union",
  "US - Louisiana - Vermilion",
  "US - Louisiana - Vernon",
  "US - Louisiana - Washington",
  "US - Louisiana - Webster",
  "US - Louisiana - West Baton Rouge",
  "US - Louisiana - West Carroll",
  "US - Louisiana - West Feliciana",
  "US - Louisiana - Winn",
  "US - Maine - Androscoggin",
  "US - Maine - Aroostook",
  "US - Maine - Cumberland",
  "US - Maine - Franklin",
  "US - Maine - Hancock",
  "US - Maine - Kennebec",
  "US - Maine - Knox",
  "US - Maine - Lincoln",
  "US - Maine - Oxford",
  "US - Maine - Penobscot",
  "US - Maine - Piscataquis",
  "US - Maine - Somerset",
  "US - Maine - Waldo",
  "US - Maine - Washington",
  "US - Maine - York",
  "US - Maryland - Allegany",
  "US - Maryland - Anne Arundel",
  "US - Maryland - Baltimore",
  "US - Maryland - Baltimore City",
  "US - Maryland - Calvert",
  "US - Maryland - Caroline",
  "US - Maryland - Carroll",
  "US - Maryland - Cecil",
  "US - Maryland - Charles",
  "US - Maryland - Dorchester",
  "US - Maryland - Frederick",
  "US - Maryland - Garrett",
  "US - Maryland - Harford",
  "US - Maryland - Howard",
  "US - Maryland - Kent",
  "US - Maryland - Montgomery",
  "US - Maryland - Prince George's",
  "US - Maryland - Queen Anne's",
  "US - Maryland - Somerset",
  "US - Maryland - St. Mary's",
  "US - Maryland - Talbot",
  "US - Maryland - Washington",
  "US - Maryland - Wicomico",
  "US - Maryland - Worcester",
  "US - Massachusetts - Barnstable",
  "US - Massachusetts - Berkshire",
  "US - Massachusetts - Bristol",
  "US - Massachusetts - Dukes and Nantucket",
  "US - Massachusetts - Essex",
  "US - Massachusetts - Franklin",
  "US - Massachusetts - Hampden",
  "US - Massachusetts - Hampshire",
  "US - Massachusetts - Middlesex",
  "US - Massachusetts - Norfolk",
  "US - Massachusetts - Plymouth",
  "US - Massachusetts - Suffolk",
  "US - Massachusetts - Worcester",
  "US - Michigan - Alcona",
  "US - Michigan - Alger",
  "US - Michigan - Allegan",
  "US - Michigan - Alpena",
  "US - Michigan - Antrim",
  "US - Michigan - Arenac",
  "US - Michigan - Baraga",
  "US - Michigan - Barry",
  "US - Michigan - Bay",
  "US - Michigan - Benzie",
  "US - Michigan - Berrien",
  "US - Michigan - Branch",
  "US - Michigan - Calhoun",
  "US - Michigan - Cass",
  "US - Michigan - Charlevoix",
  "US - Michigan - Cheboygan",
  "US - Michigan - Chippewa",
  "US - Michigan - Clare",
  "US - Michigan - Clinton",
  "US - Michigan - Crawford",
  "US - Michigan - Delta",
  "US - Michigan - Dickinson",
  "US - Michigan - Eaton",
  "US - Michigan - Emmet",
  "US - Michigan - Federal Correctional Institution (FCI)",
  "US - Michigan - Genesee",
  "US - Michigan - Gladwin",
  "US - Michigan - Gogebic",
  "US - Michigan - Grand Traverse",
  "US - Michigan - Gratiot",
  "US - Michigan - Hillsdale",
  "US - Michigan - Houghton",
  "US - Michigan - Huron",
  "US - Michigan - Ingham",
  "US - Michigan - Ionia",
  "US - Michigan - Iosco",
  "US - Michigan - Iron",
  "US - Michigan - Isabella",
  "US - Michigan - Jackson",
  "US - Michigan - Kalamazoo",
  "US - Michigan - Kalkaska",
  "US - Michigan - Kent",
  "US - Michigan - Keweenaw",
  "US - Michigan - Lake",
  "US - Michigan - Lapeer",
  "US - Michigan - Leelanau",
  "US - Michigan - Lenawee",
  "US - Michigan - Livingston",
  "US - Michigan - Mackinac",
  "US - Michigan - Macomb",
  "US - Michigan - Manistee",
  "US - Michigan - Marquette",
  "US - Michigan - Mason",
  "US - Michigan - Mecosta",
  "US - Michigan - Menominee",
  "US - Michigan - Michigan Department of Corrections (MDOC)",
  "US - Michigan - Midland",
  "US - Michigan - Missaukee",
  "US - Michigan - Monroe",
  "US - Michigan - Montcalm",
  "US - Michigan - Montmorency",
  "US - Michigan - Muskegon",
  "US - Michigan - Newaygo",
  "US - Michigan - Oakland",
  "US - Michigan - Oceana",
  "US - Michigan - Ogemaw",
  "US - Michigan - Ontonagon",
  "US - Michigan - Osceola",
  "US - Michigan - Oscoda",
  "US - Michigan - Otsego",
  "US - Michigan - Ottawa",
  "US - Michigan - Out of MI",
  "US - Michigan - Presque Isle",
  "US - Michigan - Roscommon",
  "US - Michigan - Saginaw",
  "US - Michigan - Sanilac",
  "US - Michigan - Schoolcraft",
  "US - Michigan - Shiawassee",
  "US - Michigan - St. Clair",
  "US - Michigan - St. Joseph",
  "US - Michigan - Tuscola",
  "US - Michigan - Van Buren",
  "US - Michigan - Washtenaw",
  "US - Michigan - Wayne",
  "US - Michigan - Wexford",
  "US - Minnesota - Aitkin",
  "US - Minnesota - Anoka",
  "US - Minnesota - Becker",
  "US - Minnesota - Beltrami",
  "US - Minnesota - Benton",
  "US - Minnesota - Big Stone",
  "US - Minnesota - Blue Earth",
  "US - Minnesota - Brown",
  "US - Minnesota - Carlton",
  "US - Minnesota - Carver",
  "US - Minnesota - Cass",
  "US - Minnesota - Chippewa",
  "US - Minnesota - Chisago",
  "US - Minnesota - Clay",
  "US - Minnesota - Clearwater",
  "US - Minnesota - Cottonwood",
  "US - Minnesota - Crow Wing",
  "US - Minnesota - Dakota",
  "US - Minnesota - Dodge",
  "US - Minnesota - Douglas",
  "US - Minnesota - Faribault",
  "US - Minnesota - Freeborn",
  "US - Minnesota - Goodhue",
  "US - Minnesota - Grant",
  "US - Minnesota - Hennepin",
  "US - Minnesota - Houston",
  "US - Minnesota - Hubbard",
  "US - Minnesota - Isanti",
  "US - Minnesota - Itasca",
  "US - Minnesota - Jackson",
  "US - Minnesota - Kanabec",
  "US - Minnesota - Kandiyohi",
  "US - Minnesota - Kittson",
  "US - Minnesota - Koochiching",
  "US - Minnesota - Lac qui Parle",
  "US - Minnesota - Lake",
  "US - Minnesota - Lake of the Woods",
  "US - Minnesota - Le Sueur",
  "US - Minnesota - Lincoln",
  "US - Minnesota - Lyon",
  "US - Minnesota - Mahnomen",
  "US - Minnesota - Marshall",
  "US - Minnesota - Martin",
  "US - Minnesota - McLeod",
  "US - Minnesota - Meeker",
  "US - Minnesota - Mille Lacs",
  "US - Minnesota - Morrison",
  "US - Minnesota - Mower",
  "US - Minnesota - Murray",
  "US - Minnesota - Nicollet",
  "US - Minnesota - Nobles",
  "US - Minnesota - Norman",
  "US - Minnesota - Olmsted",
  "US - Minnesota - Otter Tail",
  "US - Minnesota - Pennington",
  "US - Minnesota - Pine",
  "US - Minnesota - Pipestone",
  "US - Minnesota - Polk",
  "US - Minnesota - Pope",
  "US - Minnesota - Ramsey",
  "US - Minnesota - Red Lake",
  "US - Minnesota - Redwood",
  "US - Minnesota - Renville",
  "US - Minnesota - Rice",
  "US - Minnesota - Rock",
  "US - Minnesota - Roseau",
  "US - Minnesota - Scott",
  "US - Minnesota - Sherburne",
  "US - Minnesota - Sibley",
  "US - Minnesota - St. Louis",
  "US - Minnesota - Stearns",
  "US - Minnesota - Steele",
  "US - Minnesota - Stevens",
  "US - Minnesota - Swift",
  "US - Minnesota - Todd",
  "US - Minnesota - Traverse",
  "US - Minnesota - Wabasha",
  "US - Minnesota - Wadena",
  "US - Minnesota - Waseca",
  "US - Minnesota - Washington",
  "US - Minnesota - Watonwan",
  "US - Minnesota - Wilkin",
  "US - Minnesota - Winona",
  "US - Minnesota - Wright",
  "US - Minnesota - Yellow Medicine",
  "US - Mississippi - Adams",
  "US - Mississippi - Alcorn",
  "US - Mississippi - Amite",
  "US - Mississippi - Attala",
  "US - Mississippi - Benton",
  "US - Mississippi - Bolivar",
  "US - Mississippi - Calhoun",
  "US - Mississippi - Carroll",
  "US - Mississippi - Chickasaw",
  "US - Mississippi - Choctaw",
  "US - Mississippi - Claiborne",
  "US - Mississippi - Clarke",
  "US - Mississippi - Clay",
  "US - Mississippi - Coahoma",
  "US - Mississippi - Copiah",
  "US - Mississippi - Covington",
  "US - Mississippi - DeSoto",
  "US - Mississippi - Forrest",
  "US - Mississippi - Franklin",
  "US - Mississippi - George",
  "US - Mississippi - Greene",
  "US - Mississippi - Grenada",
  "US - Mississippi - Hancock",
  "US - Mississippi - Harrison",
  "US - Mississippi - Hinds",
  "US - Mississippi - Holmes",
  "US - Mississippi - Humphreys",
  "US - Mississippi - Issaquena",
  "US - Mississippi - Itawamba",
  "US - Mississippi - Jackson",
  "US - Mississippi - Jasper",
  "US - Mississippi - Jefferson",
  "US - Mississippi - Jefferson Davis",
  "US - Mississippi - Jones",
  "US - Mississippi - Kemper",
  "US - Mississippi - Lafayette",
  "US - Mississippi - Lamar",
  "US - Mississippi - Lauderdale",
  "US - Mississippi - Lawrence",
  "US - Mississippi - Leake",
  "US - Mississippi - Lee",
  "US - Mississippi - Leflore",
  "US - Mississippi - Lincoln",
  "US - Mississippi - Lowndes",
  "US - Mississippi - Madison",
  "US - Mississippi - Marion",
  "US - Mississippi - Marshall",
  "US - Mississippi - Monroe",
  "US - Mississippi - Montgomery",
  "US - Mississippi - Neshoba",
  "US - Mississippi - Newton",
  "US - Mississippi - Noxubee",
  "US - Mississippi - Oktibbeha",
  "US - Mississippi - Panola",
  "US - Mississippi - Pearl River",
  "US - Mississippi - Perry",
  "US - Mississippi - Pike",
  "US - Mississippi - Pontotoc",
  "US - Mississippi - Prentiss",
  "US - Mississippi - Quitman",
  "US - Mississippi - Rankin",
  "US - Mississippi - Scott",
  "US - Mississippi - Sharkey",
  "US - Mississippi - Simpson",
  "US - Mississippi - Smith",
  "US - Mississippi - Stone",
  "US - Mississippi - Sunflower",
  "US - Mississippi - Tallahatchie",
  "US - Mississippi - Tate",
  "US - Mississippi - Tippah",
  "US - Mississippi - Tishomingo",
  "US - Mississippi - Tunica",
  "US - Mississippi - Union",
  "US - Mississippi - Walthall",
  "US - Mississippi - Warren",
  "US - Mississippi - Washington",
  "US - Mississippi - Wayne",
  "US - Mississippi - Webster",
  "US - Mississippi - Wilkinson",
  "US - Mississippi - Winston",
  "US - Mississippi - Yalobusha",
  "US - Mississippi - Yazoo",
  "US - Missouri - Adair",
  "US - Missouri - Andrew",
  "US - Missouri - Atchison",
  "US - Missouri - Audrain",
  "US - Missouri - Barry",
  "US - Missouri - Barton",
  "US - Missouri - Bates",
  "US - Missouri - Benton",
  "US - Missouri - Bollinger",
  "US - Missouri - Boone",
  "US - Missouri - Buchanan",
  "US - Missouri - Butler",
  "US - Missouri - Caldwell",
  "US - Missouri - Callaway",
  "US - Missouri - Camden",
  "US - Missouri - Cape Girardeau",
  "US - Missouri - Carroll",
  "US - Missouri - Carter",
  "US - Missouri - Cass",
  "US - Missouri - Cedar",
  "US - Missouri - Chariton",
  "US - Missouri - Christian",
  "US - Missouri - Clark",
  "US - Missouri - Clay",
  "US - Missouri - Clinton",
  "US - Missouri - Cole",
  "US - Missouri - Cooper",
  "US - Missouri - Crawford",
  "US - Missouri - Dade",
  "US - Missouri - Dallas",
  "US - Missouri - Daviess",
  "US - Missouri - DeKalb",
  "US - Missouri - Dent",
  "US - Missouri - Douglas",
  "US - Missouri - Dunklin",
  "US - Missouri - Franklin",
  "US - Missouri - Gasconade",
  "US - Missouri - Gentry",
  "US - Missouri - Greene",
  "US - Missouri - Grundy",
  "US - Missouri - Harrison",
  "US - Missouri - Henry",
  "US - Missouri - Hickory",
  "US - Missouri - Holt",
  "US - Missouri - Howard",
  "US - Missouri - Howell",
  "US - Missouri - Iron",
  "US - Missouri - Jackson",
  "US - Missouri - Jasper",
  "US - Missouri - Jefferson",
  "US - Missouri - Johnson",
  "US - Missouri - Kansas City",
  "US - Missouri - Knox",
  "US - Missouri - Laclede",
  "US - Missouri - Lafayette",
  "US - Missouri - Lawrence",
  "US - Missouri - Lewis",
  "US - Missouri - Lincoln",
  "US - Missouri - Linn",
  "US - Missouri - Livingston",
  "US - Missouri - Macon",
  "US - Missouri - Madison",
  "US - Missouri - Maries",
  "US - Missouri - Marion",
  "US - Missouri - McDonald",
  "US - Missouri - Mercer",
  "US - Missouri - Miller",
  "US - Missouri - Mississippi",
  "US - Missouri - Moniteau",
  "US - Missouri - Monroe",
  "US - Missouri - Montgomery",
  "US - Missouri - Morgan",
  "US - Missouri - New Madrid",
  "US - Missouri - Newton",
  "US - Missouri - Nodaway",
  "US - Missouri - Oregon",
  "US - Missouri - Osage",
  "US - Missouri - Ozark",
  "US - Missouri - Pemiscot",
  "US - Missouri - Perry",
  "US - Missouri - Pettis",
  "US - Missouri - Phelps",
  "US - Missouri - Pike",
  "US - Missouri - Platte",
  "US - Missouri - Polk",
  "US - Missouri - Pulaski",
  "US - Missouri - Putnam",
  "US - Missouri - Ralls",
  "US - Missouri - Randolph",
  "US - Missouri - Ray",
  "US - Missouri - Reynolds",
  "US - Missouri - Ripley",
  "US - Missouri - Saline",
  "US - Missouri - Schuyler",
  "US - Missouri - Scotland",
  "US - Missouri - Scott",
  "US - Missouri - Shannon",
  "US - Missouri - Shelby",
  "US - Missouri - St. Charles",
  "US - Missouri - St.Clair",
  "US - Missouri - St. Francois",
  "US - Missouri - St. Louis",
  "US - Missouri - St. Louis City",
  "US - Missouri - Ste. Genevieve",
  "US - Missouri - Stoddard",
  "US - Missouri - Stone",
  "US - Missouri - Sullivan",
  "US - Missouri - Taney",
  "US - Missouri - Texas",
  "US - Missouri - Vernon",
  "US - Missouri - Warren",
  "US - Missouri - Washington",
  "US - Missouri - Wayne",
  "US - Missouri - Webster",
  "US - Missouri - Worth",
  "US - Missouri - Wright",
  "US - Montana - Beaverhead",
  "US - Montana - Big Horn",
  "US - Montana - Blaine",
  "US - Montana - Broadwater",
  "US - Montana - Carbon",
  "US - Montana - Carter",
  "US - Montana - Cascade",
  "US - Montana - Chouteau",
  "US - Montana - Custer",
  "US - Montana - Daniels",
  "US - Montana - Dawson",
  "US - Montana - Deer Lodge",
  "US - Montana - Fallon",
  "US - Montana - Fergus",
  "US - Montana - Flathead",
  "US - Montana - Gallatin",
  "US - Montana - Garfield",
  "US - Montana - Glacier",
  "US - Montana - Granite",
  "US - Montana - Hill",
  "US - Montana - Jefferson",
  "US - Montana - Lake",
  "US - Montana - Lewis and Clark",
  "US - Montana - Liberty",
  "US - Montana - Lincoln",
  "US - Montana - Madison",
  "US - Montana - Meagher",
  "US - Montana - Missoula",
  "US - Montana - Musselshell",
  "US - Montana - Park",
  "US - Montana - Petroleum",
  "US - Montana - Phillips",
  "US - Montana - Pondera",
  "US - Montana - Powder River",
  "US - Montana - Powell",
  "US - Montana - Prairie",
  "US - Montana - Ravalli",
  "US - Montana - Richland",
  "US - Montana - Roosevelt",
  "US - Montana - Rosebud",
  "US - Montana - Sanders",
  "US - Montana - Sheridan",
  "US - Montana - Silver Bow",
  "US - Montana - Stillwater",
  "US - Montana - Sweet Grass",
  "US - Montana - Teton",
  "US - Montana - Toole",
  "US - Montana - Treasure",
  "US - Montana - Valley",
  "US - Montana - Wheatland",
  "US - Montana - Wibaux",
  "US - Montana - Yellowstone",
  "US - Nebraska - Adams",
  "US - Nebraska - Antelope",
  "US - Nebraska - Boone",
  "US - Nebraska - Box Butte",
  "US - Nebraska - Boyd",
  "US - Nebraska - Brown",
  "US - Nebraska - Buffalo",
  "US - Nebraska - Burt",
  "US - Nebraska - Butler",
  "US - Nebraska - Cass",
  "US - Nebraska - Cedar",
  "US - Nebraska - Chase",
  "US - Nebraska - Cherry",
  "US - Nebraska - Cheyenne",
  "US - Nebraska - Clay",
  "US - Nebraska - Colfax",
  "US - Nebraska - Cuming",
  "US - Nebraska - Custer",
  "US - Nebraska - Dakota",
  "US - Nebraska - Dawes",
  "US - Nebraska - Dawson",
  "US - Nebraska - Dixon",
  "US - Nebraska - Dodge",
  "US - Nebraska - Douglas",
  "US - Nebraska - Dundy",
  "US - Nebraska - Fillmore",
  "US - Nebraska - Franklin",
  "US - Nebraska - Frontier",
  "US - Nebraska - Furnas",
  "US - Nebraska - Gage",
  "US - Nebraska - Garfield",
  "US - Nebraska - Gosper",
  "US - Nebraska - Grant",
  "US - Nebraska - Hall",
  "US - Nebraska - Hamilton",
  "US - Nebraska - Hitchcock",
  "US - Nebraska - Holt",
  "US - Nebraska - Hooker",
  "US - Nebraska - Howard",
  "US - Nebraska - Johnson",
  "US - Nebraska - Kearney",
  "US - Nebraska - Keith",
  "US - Nebraska - Kimball",
  "US - Nebraska - Knox",
  "US - Nebraska - Lancaster",
  "US - Nebraska - Lincoln",
  "US - Nebraska - Madison",
  "US - Nebraska - Merrick",
  "US - Nebraska - Morrill",
  "US - Nebraska - Nance",
  "US - Nebraska - Nemaha",
  "US - Nebraska - Nuckolls",
  "US - Nebraska - Otoe",
  "US - Nebraska - Pawnee",
  "US - Nebraska - Perkins",
  "US - Nebraska - Phelps",
  "US - Nebraska - Pierce",
  "US - Nebraska - Platte",
  "US - Nebraska - Polk",
  "US - Nebraska - Red Willow",
  "US - Nebraska - Richardson",
  "US - Nebraska - Rock",
  "US - Nebraska - Saline",
  "US - Nebraska - Sarpy",
  "US - Nebraska - Saunders",
  "US - Nebraska - Scotts Bluff",
  "US - Nebraska - Seward",
  "US - Nebraska - Sheridan",
  "US - Nebraska - Sherman",
  "US - Nebraska - Stanton",
  "US - Nebraska - Thayer",
  "US - Nebraska - Thurston",
  "US - Nebraska - Valley",
  "US - Nebraska - Washington",
  "US - Nebraska - Wayne",
  "US - Nebraska - Webster",
  "US - Nebraska - York",
  "US - Nevada - Carson City",
  "US - Nevada - Churchill",
  "US - Nevada - Clark",
  "US - Nevada - Douglas",
  "US - Nevada - Elko",
  "US - Nevada - Humboldt",
  "US - Nevada - Lander",
  "US - Nevada - Lincoln",
  "US - Nevada - Lyon",
  "US - Nevada - Mineral",
  "US - Nevada - Nye",
  "US - Nevada - Pershing",
  "US - Nevada - Storey",
  "US - Nevada - Washoe",
  "US - Nevada - White Pine",
  "US - New Hampshire - Belknap",
  "US - New Hampshire - Carroll",
  "US - New Hampshire - Cheshire",
  "US - New Hampshire - Coos",
  "US - New Hampshire - Grafton",
  "US - New Hampshire - Hillsborough",
  "US - New Hampshire - Merrimack",
  "US - New Hampshire - Rockingham",
  "US - New Hampshire - Strafford",
  "US - New Hampshire - Sullivan",
  "US - New Jersey - Atlantic",
  "US - New Jersey - Bergen",
  "US - New Jersey - Burlington",
  "US - New Jersey - Camden",
  "US - New Jersey - Cape May",
  "US - New Jersey - Cumberland",
  "US - New Jersey - Essex",
  "US - New Jersey - Gloucester",
  "US - New Jersey - Hudson",
  "US - New Jersey - Hunterdon",
  "US - New Jersey - Mercer",
  "US - New Jersey - Middlesex",
  "US - New Jersey - Monmouth",
  "US - New Jersey - Morris",
  "US - New Jersey - Ocean",
  "US - New Jersey - Passaic",
  "US - New Jersey - Salem",
  "US - New Jersey - Somerset",
  "US - New Jersey - Sussex",
  "US - New Jersey - Union",
  "US - New Jersey - Warren",
  "US - New Mexico - Bernalillo",
  "US - New Mexico - Catron",
  "US - New Mexico - Chaves",
  "US - New Mexico - Cibola",
  "US - New Mexico - Colfax",
  "US - New Mexico - Curry",
  "US - New Mexico - Dona Ana",
  "US - New Mexico - Eddy",
  "US - New Mexico - Grant",
  "US - New Mexico - Guadalupe",
  "US - New Mexico - Hidalgo",
  "US - New Mexico - Lea",
  "US - New Mexico - Lincoln",
  "US - New Mexico - Luna",
  "US - New Mexico - McKinley",
  "US - New Mexico - Otero",
  "US - New Mexico - Quay",
  "US - New Mexico - Rio Arriba",
  "US - New Mexico - Roosevelt",
  "US - New Mexico - San Juan",
  "US - New Mexico - San Miguel",
  "US - New Mexico - Sandoval",
  "US - New Mexico - Santa Fe",
  "US - New Mexico - Sierra",
  "US - New Mexico - Socorro",
  "US - New Mexico - Taos",
  "US - New Mexico - Torrance",
  "US - New Mexico - Union",
  "US - New Mexico - Valencia",
  "US - New York - Albany",
  "US - New York - Allegany",
  "US - New York - Bronx",
  "US - New York - Broome",
  "US - New York - Cattaraugus",
  "US - New York - Cayuga",
  "US - New York - Chautauqua",
  "US - New York - Chemung",
  "US - New York - Chenango",
  "US - New York - Clinton",
  "US - New York - Columbia",
  "US - New York - Cortland",
  "US - New York - Delaware",
  "US - New York - Dutchess",
  "US - New York - Erie",
  "US - New York - Essex",
  "US - New York - Franklin",
  "US - New York - Fulton",
  "US - New York - Genesee",
  "US - New York - Greene",
  "US - New York - Hamilton",
  "US - New York - Herkimer",
  "US - New York - Jefferson",
  "US - New York - Kings",
  "US - New York - Lewis",
  "US - New York - Livingston",
  "US - New York - Madison",
  "US - New York - Monroe",
  "US - New York - Montgomery",
  "US - New York - Nassau",
  "US - New York - New York",
  "US - New York - Niagara",
  "US - New York - Oneida",
  "US - New York - Onondaga",
  "US - New York - Ontario",
  "US - New York - Orange",
  "US - New York - Orleans",
  "US - New York - Oswego",
  "US - New York - Otsego",
  "US - New York - Putnam",
  "US - New York - Queens",
  "US - New York - Rensselaer",
  "US - New York - Richmond",
  "US - New York - Rockland",
  "US - New York - Saratoga",
  "US - New York - Schenectady",
  "US - New York - Schoharie",
  "US - New York - Schuyler",
  "US - New York - Seneca",
  "US - New York - St. Lawrence",
  "US - New York - Steuben",
  "US - New York - Suffolk",
  "US - New York - Sullivan",
  "US - New York - Tioga",
  "US - New York - Tompkins",
  "US - New York - Ulster",
  "US - New York - Warren",
  "US - New York - Washington",
  "US - New York - Wayne",
  "US - New York - Westchester",
  "US - New York - Wyoming",
  "US - New York - Yates",
  "US - North Carolina - Alamance",
  "US - North Carolina - Alexander",
  "US - North Carolina - Alleghany",
  "US - North Carolina - Anson",
  "US - North Carolina - Ashe",
  "US - North Carolina - Avery",
  "US - North Carolina - Beaufort",
  "US - North Carolina - Bertie",
  "US - North Carolina - Bladen",
  "US - North Carolina - Brunswick",
  "US - North Carolina - Buncombe",
  "US - North Carolina - Burke",
  "US - North Carolina - Cabarrus",
  "US - North Carolina - Caldwell",
  "US - North Carolina - Camden",
  "US - North Carolina - Carteret",
  "US - North Carolina - Caswell",
  "US - North Carolina - Catawba",
  "US - North Carolina - Chatham",
  "US - North Carolina - Cherokee",
  "US - North Carolina - Chowan",
  "US - North Carolina - Clay",
  "US - North Carolina - Cleveland",
  "US - North Carolina - Columbus",
  "US - North Carolina - Craven",
  "US - North Carolina - Cumberland",
  "US - North Carolina - Currituck",
  "US - North Carolina - Dare",
  "US - North Carolina - Davidson",
  "US - North Carolina - Davie",
  "US - North Carolina - Duplin",
  "US - North Carolina - Durham",
  "US - North Carolina - Edgecombe",
  "US - North Carolina - Forsyth",
  "US - North Carolina - Franklin",
  "US - North Carolina - Gaston",
  "US - North Carolina - Gates",
  "US - North Carolina - Graham",
  "US - North Carolina - Granville",
  "US - North Carolina - Greene",
  "US - North Carolina - Guilford",
  "US - North Carolina - Halifax",
  "US - North Carolina - Harnett",
  "US - North Carolina - Haywood",
  "US - North Carolina - Henderson",
  "US - North Carolina - Hertford",
  "US - North Carolina - Hoke",
  "US - North Carolina - Hyde",
  "US - North Carolina - Iredell",
  "US - North Carolina - Jackson",
  "US - North Carolina - Johnston",
  "US - North Carolina - Jones",
  "US - North Carolina - Lee",
  "US - North Carolina - Lenoir",
  "US - North Carolina - Lincoln",
  "US - North Carolina - Macon",
  "US - North Carolina - Madison",
  "US - North Carolina - Martin",
  "US - North Carolina - McDowell",
  "US - North Carolina - Mecklenburg",
  "US - North Carolina - Mitchell",
  "US - North Carolina - Montgomery",
  "US - North Carolina - Moore",
  "US - North Carolina - Nash",
  "US - North Carolina - New Hanover",
  "US - North Carolina - Northampton",
  "US - North Carolina - Onslow",
  "US - North Carolina - Orange",
  "US - North Carolina - Pamlico",
  "US - North Carolina - Pasquotank",
  "US - North Carolina - Pender",
  "US - North Carolina - Perquimans",
  "US - North Carolina - Person",
  "US - North Carolina - Pitt",
  "US - North Carolina - Polk",
  "US - North Carolina - Randolph",
  "US - North Carolina - Richmond",
  "US - North Carolina - Robeson",
  "US - North Carolina - Rockingham",
  "US - North Carolina - Rowan",
  "US - North Carolina - Rutherford",
  "US - North Carolina - Sampson",
  "US - North Carolina - Scotland",
  "US - North Carolina - Stanly",
  "US - North Carolina - Stokes",
  "US - North Carolina - Surry",
  "US - North Carolina - Swain",
  "US - North Carolina - Transylvania",
  "US - North Carolina - Tyrrell",
  "US - North Carolina - Union",
  "US - North Carolina - Vance",
  "US - North Carolina - Wake",
  "US - North Carolina - Warren",
  "US - North Carolina - Washington",
  "US - North Carolina - Watauga",
  "US - North Carolina - Wayne",
  "US - North Carolina - Wilkes",
  "US - North Carolina - Wilson",
  "US - North Carolina - Yadkin",
  "US - North Carolina - Yancey",
  "US - North Dakota - Adams",
  "US - North Dakota - Barnes",
  "US - North Dakota - Benson",
  "US - North Dakota - Bottineau",
  "US - North Dakota - Bowman",
  "US - North Dakota - Burke",
  "US - North Dakota - Burleigh",
  "US - North Dakota - Cass",
  "US - North Dakota - Cavalier",
  "US - North Dakota - Dickey",
  "US - North Dakota - Divide",
  "US - North Dakota - Dunn",
  "US - North Dakota - Eddy",
  "US - North Dakota - Emmons",
  "US - North Dakota - Foster",
  "US - North Dakota - Grand Forks",
  "US - North Dakota - Grant",
  "US - North Dakota - Griggs",
  "US - North Dakota - Hettinger",
  "US - North Dakota - Kidder",
  "US - North Dakota - LaMoure",
  "US - North Dakota - Logan",
  "US - North Dakota - McHenry",
  "US - North Dakota - McIntosh",
  "US - North Dakota - McKenzie",
  "US - North Dakota - McLean",
  "US - North Dakota - Mercer",
  "US - North Dakota - Morton",
  "US - North Dakota - Mountrail",
  "US - North Dakota - Nelson",
  "US - North Dakota - Oliver",
  "US - North Dakota - Pembina",
  "US - North Dakota - Pierce",
  "US - North Dakota - Ramsey",
  "US - North Dakota - Ransom",
  "US - North Dakota - Renville",
  "US - North Dakota - Richland",
  "US - North Dakota - Rolette",
  "US - North Dakota - Sargent",
  "US - North Dakota - Sheridan",
  "US - North Dakota - Sioux",
  "US - North Dakota - Stark",
  "US - North Dakota - Steele",
  "US - North Dakota - Stutsman",
  "US - North Dakota - Towner",
  "US - North Dakota - Traill",
  "US - North Dakota - Walsh",
  "US - North Dakota - Ward",
  "US - North Dakota - Wells",
  "US - North Dakota - Williams",
  "US - Northern Mariana Islands",
  "US - Ohio - Adams",
  "US - Ohio - Allen",
  "US - Ohio - Ashland",
  "US - Ohio - Ashtabula",
  "US - Ohio - Athens",
  "US - Ohio - Auglaize",
  "US - Ohio - Belmont",
  "US - Ohio - Brown",
  "US - Ohio - Butler",
  "US - Ohio - Carroll",
  "US - Ohio - Champaign",
  "US - Ohio - Clark",
  "US - Ohio - Clermont",
  "US - Ohio - Clinton",
  "US - Ohio - Columbiana",
  "US - Ohio - Coshocton",
  "US - Ohio - Crawford",
  "US - Ohio - Cuyahoga",
  "US - Ohio - Darke",
  "US - Ohio - Defiance",
  "US - Ohio - Delaware",
  "US - Ohio - Erie",
  "US - Ohio - Fairfield",
  "US - Ohio - Fayette",
  "US - Ohio - Franklin",
  "US - Ohio - Fulton",
  "US - Ohio - Gallia",
  "US - Ohio - Geauga",
  "US - Ohio - Greene",
  "US - Ohio - Guernsey",
  "US - Ohio - Hamilton",
  "US - Ohio - Hancock",
  "US - Ohio - Hardin",
  "US - Ohio - Harrison",
  "US - Ohio - Henry",
  "US - Ohio - Highland",
  "US - Ohio - Hocking",
  "US - Ohio - Holmes",
  "US - Ohio - Huron",
  "US - Ohio - Jackson",
  "US - Ohio - Jefferson",
  "US - Ohio - Knox",
  "US - Ohio - Lake",
  "US - Ohio - Lawrence",
  "US - Ohio - Licking",
  "US - Ohio - Logan",
  "US - Ohio - Lorain",
  "US - Ohio - Lucas",
  "US - Ohio - Madison",
  "US - Ohio - Mahoning",
  "US - Ohio - Marion",
  "US - Ohio - Medina",
  "US - Ohio - Meigs",
  "US - Ohio - Mercer",
  "US - Ohio - Miami",
  "US - Ohio - Monroe",
  "US - Ohio - Montgomery",
  "US - Ohio - Morgan",
  "US - Ohio - Morrow",
  "US - Ohio - Muskingum",
  "US - Ohio - Noble",
  "US - Ohio - Ottawa",
  "US - Ohio - Paulding",
  "US - Ohio - Perry",
  "US - Ohio - Pickaway",
  "US - Ohio - Pike",
  "US - Ohio - Portage",
  "US - Ohio - Preble",
  "US - Ohio - Putnam",
  "US - Ohio - Richland",
  "US - Ohio - Ross",
  "US - Ohio - Sandusky",
  "US - Ohio - Scioto",
  "US - Ohio - Seneca",
  "US - Ohio - Shelby",
  "US - Ohio - Stark",
  "US - Ohio - Summit",
  "US - Ohio - Trumbull",
  "US - Ohio - Tuscarawas",
  "US - Ohio - Union",
  "US - Ohio - Van Wert",
  "US - Ohio - Vinton",
  "US - Ohio - Warren",
  "US - Ohio - Washington",
  "US - Ohio - Wayne",
  "US - Ohio - Williams",
  "US - Ohio - Wood",
  "US - Ohio - Wyandot",
  "US - Oklahoma - Adair",
  "US - Oklahoma - Alfalfa",
  "US - Oklahoma - Atoka",
  "US - Oklahoma - Beaver",
  "US - Oklahoma - Beckham",
  "US - Oklahoma - Blaine",
  "US - Oklahoma - Bryan",
  "US - Oklahoma - Caddo",
  "US - Oklahoma - Canadian",
  "US - Oklahoma - Carter",
  "US - Oklahoma - Cherokee",
  "US - Oklahoma - Choctaw",
  "US - Oklahoma - Cimarron",
  "US - Oklahoma - Cleveland",
  "US - Oklahoma - Coal",
  "US - Oklahoma - Comanche",
  "US - Oklahoma - Cotton",
  "US - Oklahoma - Craig",
  "US - Oklahoma - Creek",
  "US - Oklahoma - Custer",
  "US - Oklahoma - Delaware",
  "US - Oklahoma - Dewey",
  "US - Oklahoma - Garfield",
  "US - Oklahoma - Garvin",
  "US - Oklahoma - Grady",
  "US - Oklahoma - Grant",
  "US - Oklahoma - Greer",
  "US - Oklahoma - Harper",
  "US - Oklahoma - Haskell",
  "US - Oklahoma - Hughes",
  "US - Oklahoma - Jackson",
  "US - Oklahoma - Jefferson",
  "US - Oklahoma - Johnston",
  "US - Oklahoma - Kay",
  "US - Oklahoma - Kingfisher",
  "US - Oklahoma - Kiowa",
  "US - Oklahoma - Latimer",
  "US - Oklahoma - Le Flore",
  "US - Oklahoma - Lincoln",
  "US - Oklahoma - Logan",
  "US - Oklahoma - Love",
  "US - Oklahoma - Major",
  "US - Oklahoma - Marshall",
  "US - Oklahoma - Mayes",
  "US - Oklahoma - McClain",
  "US - Oklahoma - McCurtain",
  "US - Oklahoma - McIntosh",
  "US - Oklahoma - Murray",
  "US - Oklahoma - Muskogee",
  "US - Oklahoma - Noble",
  "US - Oklahoma - Nowata",
  "US - Oklahoma - Okfuskee",
  "US - Oklahoma - Oklahoma",
  "US - Oklahoma - Okmulgee",
  "US - Oklahoma - Osage",
  "US - Oklahoma - Ottawa",
  "US - Oklahoma - Pawnee",
  "US - Oklahoma - Payne",
  "US - Oklahoma - Pittsburg",
  "US - Oklahoma - Pontotoc",
  "US - Oklahoma - Pottawatomie",
  "US - Oklahoma - Pushmataha",
  "US - Oklahoma - Roger Mills",
  "US - Oklahoma - Rogers",
  "US - Oklahoma - Seminole",
  "US - Oklahoma - Sequoyah",
  "US - Oklahoma - Stephens",
  "US - Oklahoma - Texas",
  "US - Oklahoma - Tillman",
  "US - Oklahoma - Tulsa",
  "US - Oklahoma - Wagoner",
  "US - Oklahoma - Washington",
  "US - Oklahoma - Washita",
  "US - Oklahoma - Woods",
  "US - Oklahoma - Woodward",
  "US - Oregon - Baker",
  "US - Oregon - Benton",
  "US - Oregon - Clackamas",
  "US - Oregon - Clatsop",
  "US - Oregon - Columbia",
  "US - Oregon - Coos",
  "US - Oregon - Crook",
  "US - Oregon - Curry",
  "US - Oregon - Deschutes",
  "US - Oregon - Douglas",
  "US - Oregon - Gilliam",
  "US - Oregon - Grant",
  "US - Oregon - Harney",
  "US - Oregon - Hood River",
  "US - Oregon - Jackson",
  "US - Oregon - Jefferson",
  "US - Oregon - Josephine",
  "US - Oregon - Klamath",
  "US - Oregon - Lake",
  "US - Oregon - Lane",
  "US - Oregon - Lincoln",
  "US - Oregon - Linn",
  "US - Oregon - Malheur",
  "US - Oregon - Marion",
  "US - Oregon - Morrow",
  "US - Oregon - Multnomah",
  "US - Oregon - Polk",
  "US - Oregon - Umatilla",
  "US - Oregon - Union",
  "US - Oregon - Wallowa",
  "US - Oregon - Wasco",
  "US - Oregon - Washington",
  "US - Oregon - Yamhill",
  "US - Pennsylvania - Adams",
  "US - Pennsylvania - Allegheny",
  "US - Pennsylvania - Armstrong",
  "US - Pennsylvania - Beaver",
  "US - Pennsylvania - Bedford",
  "US - Pennsylvania - Berks",
  "US - Pennsylvania - Blair",
  "US - Pennsylvania - Bradford",
  "US - Pennsylvania - Bucks",
  "US - Pennsylvania - Butler",
  "US - Pennsylvania - Cambria",
  "US - Pennsylvania - Cameron",
  "US - Pennsylvania - Carbon",
  "US - Pennsylvania - Centre",
  "US - Pennsylvania - Chester",
  "US - Pennsylvania - Clarion",
  "US - Pennsylvania - Clearfield",
  "US - Pennsylvania - Clinton",
  "US - Pennsylvania - Columbia",
  "US - Pennsylvania - Crawford",
  "US - Pennsylvania - Cumberland",
  "US - Pennsylvania - Dauphin",
  "US - Pennsylvania - Delaware",
  "US - Pennsylvania - Elk",
  "US - Pennsylvania - Erie",
  "US - Pennsylvania - Fayette",
  "US - Pennsylvania - Forest",
  "US - Pennsylvania - Franklin",
  "US - Pennsylvania - Fulton",
  "US - Pennsylvania - Greene",
  "US - Pennsylvania - Huntingdon",
  "US - Pennsylvania - Indiana",
  "US - Pennsylvania - Jefferson",
  "US - Pennsylvania - Juniata",
  "US - Pennsylvania - Lackawanna",
  "US - Pennsylvania - Lancaster",
  "US - Pennsylvania - Lawrence",
  "US - Pennsylvania - Lebanon",
  "US - Pennsylvania - Lehigh",
  "US - Pennsylvania - Luzerne",
  "US - Pennsylvania - Lycoming",
  "US - Pennsylvania - McKean",
  "US - Pennsylvania - Mercer",
  "US - Pennsylvania - Mifflin",
  "US - Pennsylvania - Monroe",
  "US - Pennsylvania - Montgomery",
  "US - Pennsylvania - Montour",
  "US - Pennsylvania - Northampton",
  "US - Pennsylvania - Northumberland",
  "US - Pennsylvania - Perry",
  "US - Pennsylvania - Philadelphia",
  "US - Pennsylvania - Pike",
  "US - Pennsylvania - Potter",
  "US - Pennsylvania - Schuylkill",
  "US - Pennsylvania - Snyder",
  "US - Pennsylvania - Somerset",
  "US - Pennsylvania - Sullivan",
  "US - Pennsylvania - Susquehanna",
  "US - Pennsylvania - Tioga",
  "US - Pennsylvania - Union",
  "US - Pennsylvania - Venango",
  "US - Pennsylvania - Warren",
  "US - Pennsylvania - Washington",
  "US - Pennsylvania - Wayne",
  "US - Pennsylvania - Westmoreland",
  "US - Pennsylvania - Wyoming",
  "US - Pennsylvania - York",
  "US - Rhode Island - Bristol",
  "US - Rhode Island - Kent",
  "US - Rhode Island - Newport",
  "US - Rhode Island - Providence",
  "US - Rhode Island - Washington",
  "US - South Carolina - Abbeville",
  "US - South Carolina - Aiken",
  "US - South Carolina - Allendale",
  "US - South Carolina - Anderson",
  "US - South Carolina - Bamberg",
  "US - South Carolina - Barnwell",
  "US - South Carolina - Beaufort",
  "US - South Carolina - Berkeley",
  "US - South Carolina - Calhoun",
  "US - South Carolina - Charleston",
  "US - South Carolina - Cherokee",
  "US - South Carolina - Chester",
  "US - South Carolina - Chesterfield",
  "US - South Carolina - Clarendon",
  "US - South Carolina - Colleton",
  "US - South Carolina - Darlington",
  "US - South Carolina - Dillon",
  "US - South Carolina - Dorchester",
  "US - South Carolina - Edgefield",
  "US - South Carolina - Fairfield",
  "US - South Carolina - Florence",
  "US - South Carolina - Georgetown",
  "US - South Carolina - Greenville",
  "US - South Carolina - Greenwood",
  "US - South Carolina - Hampton",
  "US - South Carolina - Horry",
  "US - South Carolina - Jasper",
  "US - South Carolina - Kershaw",
  "US - South Carolina - Lancaster",
  "US - South Carolina - Laurens",
  "US - South Carolina - Lee",
  "US - South Carolina - Lexington",
  "US - South Carolina - Marion",
  "US - South Carolina - Marlboro",
  "US - South Carolina - McCormick",
  "US - South Carolina - Newberry",
  "US - South Carolina - Oconee",
  "US - South Carolina - Orangeburg",
  "US - South Carolina - Pickens",
  "US - South Carolina - Richland",
  "US - South Carolina - Saluda",
  "US - South Carolina - Spartanburg",
  "US - South Carolina - Sumter",
  "US - South Carolina - Union",
  "US - South Carolina - Williamsburg",
  "US - South Carolina - York",
  "US - South Dakota - Aurora",
  "US - South Dakota - Beadle",
  "US - South Dakota - Bennett",
  "US - South Dakota - Bon Homme",
  "US - South Dakota - Brookings",
  "US - South Dakota - Brown",
  "US - South Dakota - Brule",
  "US - South Dakota - Buffalo",
  "US - South Dakota - Butte",
  "US - South Dakota - Campbell",
  "US - South Dakota - Charles Mix",
  "US - South Dakota - Clark",
  "US - South Dakota - Clay",
  "US - South Dakota - Codington",
  "US - South Dakota - Corson",
  "US - South Dakota - Custer",
  "US - South Dakota - Davison",
  "US - South Dakota - Day",
  "US - South Dakota - Deuel",
  "US - South Dakota - Dewey",
  "US - South Dakota - Douglas",
  "US - South Dakota - Edmunds",
  "US - South Dakota - Fall River",
  "US - South Dakota - Faulk",
  "US - South Dakota - Grant",
  "US - South Dakota - Gregory",
  "US - South Dakota - Haakon",
  "US - South Dakota - Hamlin",
  "US - South Dakota - Hand",
  "US - South Dakota - Hanson",
  "US - South Dakota - Hughes",
  "US - South Dakota - Hutchinson",
  "US - South Dakota - Jackson",
  "US - South Dakota - Jerauld",
  "US - South Dakota - Kingsbury",
  "US - South Dakota - Lake",
  "US - South Dakota - Lawrence",
  "US - South Dakota - Lincoln",
  "US - South Dakota - Lyman",
  "US - South Dakota - Marshall",
  "US - South Dakota - McCook",
  "US - South Dakota - McPherson",
  "US - South Dakota - Meade",
  "US - South Dakota - Mellette",
  "US - South Dakota - Miner",
  "US - South Dakota - Minnehaha",
  "US - South Dakota - Moody",
  "US - South Dakota - Oglala Lakota",
  "US - South Dakota - Pennington",
  "US - South Dakota - Perkins",
  "US - South Dakota - Potter",
  "US - South Dakota - Roberts",
  "US - South Dakota - Sanborn",
  "US - South Dakota - Spink",
  "US - South Dakota - Stanley",
  "US - South Dakota - Sully",
  "US - South Dakota - Todd",
  "US - South Dakota - Tripp",
  "US - South Dakota - Turner",
  "US - South Dakota - Union",
  "US - South Dakota - Walworth",
  "US - South Dakota - Yankton",
  "US - South Dakota - Ziebach",
  "US - Tennessee - Anderson",
  "US - Tennessee - Bedford",
  "US - Tennessee - Benton",
  "US - Tennessee - Bledsoe",
  "US - Tennessee - Blount",
  "US - Tennessee - Bradley",
  "US - Tennessee - Campbell",
  "US - Tennessee - Cannon",
  "US - Tennessee - Carroll",
  "US - Tennessee - Carter",
  "US - Tennessee - Cheatham",
  "US - Tennessee - Chester",
  "US - Tennessee - Claiborne",
  "US - Tennessee - Clay",
  "US - Tennessee - Cocke",
  "US - Tennessee - Coffee",
  "US - Tennessee - Crockett",
  "US - Tennessee - Cumberland",
  "US - Tennessee - Davidson",
  "US - Tennessee - DeKalb",
  "US - Tennessee - Decatur",
  "US - Tennessee - Dickson",
  "US - Tennessee - Dyer",
  "US - Tennessee - Fayette",
  "US - Tennessee - Fentress",
  "US - Tennessee - Franklin",
  "US - Tennessee - Gibson",
  "US - Tennessee - Giles",
  "US - Tennessee - Grainger",
  "US - Tennessee - Greene",
  "US - Tennessee - Grundy",
  "US - Tennessee - Hamblen",
  "US - Tennessee - Hamilton",
  "US - Tennessee - Hancock",
  "US - Tennessee - Hardeman",
  "US - Tennessee - Hardin",
  "US - Tennessee - Hawkins",
  "US - Tennessee - Haywood",
  "US - Tennessee - Henderson",
  "US - Tennessee - Henry",
  "US - Tennessee - Hickman",
  "US - Tennessee - Houston",
  "US - Tennessee - Humphreys",
  "US - Tennessee - Jackson",
  "US - Tennessee - Jefferson",
  "US - Tennessee - Johnson",
  "US - Tennessee - Knox",
  "US - Tennessee - Lake",
  "US - Tennessee - Lauderdale",
  "US - Tennessee - Lawrence",
  "US - Tennessee - Lewis",
  "US - Tennessee - Lincoln",
  "US - Tennessee - Loudon",
  "US - Tennessee - Macon",
  "US - Tennessee - Madison",
  "US - Tennessee - Marion",
  "US - Tennessee - Marshall",
  "US - Tennessee - Maury",
  "US - Tennessee - McMinn",
  "US - Tennessee - McNairy",
  "US - Tennessee - Meigs",
  "US - Tennessee - Monroe",
  "US - Tennessee - Montgomery",
  "US - Tennessee - Moore",
  "US - Tennessee - Morgan",
  "US - Tennessee - Obion",
  "US - Tennessee - Out of TN",
  "US - Tennessee - Overton",
  "US - Tennessee - Perry",
  "US - Tennessee - Pickett",
  "US - Tennessee - Polk",
  "US - Tennessee - Putnam",
  "US - Tennessee - Rhea",
  "US - Tennessee - Roane",
  "US - Tennessee - Robertson",
  "US - Tennessee - Rutherford",
  "US - Tennessee - Scott",
  "US - Tennessee - Sequatchie",
  "US - Tennessee - Sevier",
  "US - Tennessee - Shelby",
  "US - Tennessee - Smith",
  "US - Tennessee - Stewart",
  "US - Tennessee - Sullivan",
  "US - Tennessee - Sumner",
  "US - Tennessee - Tipton",
  "US - Tennessee - Trousdale",
  "US - Tennessee - Unicoi",
  "US - Tennessee - Union",
  "US - Tennessee - Van Buren",
  "US - Tennessee - Warren",
  "US - Tennessee - Washington",
  "US - Tennessee - Wayne",
  "US - Tennessee - Weakley",
  "US - Tennessee - White",
  "US - Tennessee - Williamson",
  "US - Tennessee - Wilson",
  "US - Texas - Anderson",
  "US - Texas - Andrews",
  "US - Texas - Angelina",
  "US - Texas - Aransas",
  "US - Texas - Archer",
  "US - Texas - Armstrong",
  "US - Texas - Atascosa",
  "US - Texas - Austin",
  "US - Texas - Bailey",
  "US - Texas - Bandera",
  "US - Texas - Bastrop",
  "US - Texas - Baylor",
  "US - Texas - Bee",
  "US - Texas - Bell",
  "US - Texas - Bexar",
  "US - Texas - Blanco",
  "US - Texas - Bosque",
  "US - Texas - Bowie",
  "US - Texas - Brazoria",
  "US - Texas - Brazos",
  "US - Texas - Brewster",
  "US - Texas - Briscoe",
  "US - Texas - Brooks",
  "US - Texas - Brown",
  "US - Texas - Burleson",
  "US - Texas - Burnet",
  "US - Texas - Caldwell",
  "US - Texas - Calhoun",
  "US - Texas - Callahan",
  "US - Texas - Cameron",
  "US - Texas - Camp",
  "US - Texas - Carson",
  "US - Texas - Cass",
  "US - Texas - Castro",
  "US - Texas - Chambers",
  "US - Texas - Cherokee",
  "US - Texas - Childress",
  "US - Texas - Clay",
  "US - Texas - Cochran",
  "US - Texas - Coke",
  "US - Texas - Coleman",
  "US - Texas - Collin",
  "US - Texas - Collingsworth",
  "US - Texas - Colorado",
  "US - Texas - Comal",
  "US - Texas - Comanche",
  "US - Texas - Concho",
  "US - Texas - Cooke",
  "US - Texas - Coryell",
  "US - Texas - Cottle",
  "US - Texas - Crane",
  "US - Texas - Crockett",
  "US - Texas - Crosby",
  "US - Texas - Culberson",
  "US - Texas - Dallam",
  "US - Texas - Dallas",
  "US - Texas - Dawson",
  "US - Texas - DeWitt",
  "US - Texas - Deaf Smith",
  "US - Texas - Delta",
  "US - Texas - Denton",
  "US - Texas - Dickens",
  "US - Texas - Dimmit",
  "US - Texas - Donley",
  "US - Texas - Duval",
  "US - Texas - Eastland",
  "US - Texas - Ector",
  "US - Texas - Edwards",
  "US - Texas - El Paso",
  "US - Texas - Ellis",
  "US - Texas - Erath",
  "US - Texas - Falls",
  "US - Texas - Fannin",
  "US - Texas - Fayette",
  "US - Texas - Fisher",
  "US - Texas - Floyd",
  "US - Texas - Foard",
  "US - Texas - Fort Bend",
  "US - Texas - Franklin",
  "US - Texas - Freestone",
  "US - Texas - Frio",
  "US - Texas - Gaines",
  "US - Texas - Galveston",
  "US - Texas - Garza",
  "US - Texas - Gillespie",
  "US - Texas - Glasscock",
  "US - Texas - Goliad",
  "US - Texas - Gonzales",
  "US - Texas - Gray",
  "US - Texas - Grayson",
  "US - Texas - Gregg",
  "US - Texas - Grimes",
  "US - Texas - Guadalupe",
  "US - Texas - Hale",
  "US - Texas - Hall",
  "US - Texas - Hamilton",
  "US - Texas - Hansford",
  "US - Texas - Hardeman",
  "US - Texas - Hardin",
  "US - Texas - Harris",
  "US - Texas - Harrison",
  "US - Texas - Haskell",
  "US - Texas - Hays",
  "US - Texas - Hemphill",
  "US - Texas - Henderson",
  "US - Texas - Hidalgo",
  "US - Texas - Hill",
  "US - Texas - Hockley",
  "US - Texas - Hood",
  "US - Texas - Hopkins",
  "US - Texas - Houston",
  "US - Texas - Howard",
  "US - Texas - Hudspeth",
  "US - Texas - Hunt",
  "US - Texas - Hutchinson",
  "US - Texas - Jack",
  "US - Texas - Jackson",
  "US - Texas - Jasper",
  "US - Texas - Jeff Davis",
  "US - Texas - Jefferson",
  "US - Texas - Jim Hogg",
  "US - Texas - Jim Wells",
  "US - Texas - Johnson",
  "US - Texas - Jones",
  "US - Texas - Karnes",
  "US - Texas - Kaufman",
  "US - Texas - Kendall",
  "US - Texas - Kenedy",
  "US - Texas - Kent",
  "US - Texas - Kerr",
  "US - Texas - Kimble",
  "US - Texas - Kinney",
  "US - Texas - Kleberg",
  "US - Texas - Knox",
  "US - Texas - La Salle",
  "US - Texas - Lamar",
  "US - Texas - Lamb",
  "US - Texas - Lampasas",
  "US - Texas - Lavaca",
  "US - Texas - Lee",
  "US - Texas - Leon",
  "US - Texas - Liberty",
  "US - Texas - Limestone",
  "US - Texas - Lipscomb",
  "US - Texas - Live Oak",
  "US - Texas - Llano",
  "US - Texas - Lubbock",
  "US - Texas - Lynn",
  "US - Texas - Madison",
  "US - Texas - Marion",
  "US - Texas - Martin",
  "US - Texas - Mason",
  "US - Texas - Matagorda",
  "US - Texas - Maverick",
  "US - Texas - McCulloch",
  "US - Texas - McLennan",
  "US - Texas - McMullen",
  "US - Texas - Medina",
  "US - Texas - Menard",
  "US - Texas - Midland",
  "US - Texas - Milam",
  "US - Texas - Mills",
  "US - Texas - Mitchell",
  "US - Texas - Montague",
  "US - Texas - Montgomery",
  "US - Texas - Moore",
  "US - Texas - Morris",
  "US - Texas - Motley",
  "US - Texas - Nacogdoches",
  "US - Texas - Navarro",
  "US - Texas - Newton",
  "US - Texas - Nolan",
  "US - Texas - Nueces",
  "US - Texas - Ochiltree",
  "US - Texas - Oldham",
  "US - Texas - Orange",
  "US - Texas - Palo Pinto",
  "US - Texas - Panola",
  "US - Texas - Parker",
  "US - Texas - Parmer",
  "US - Texas - Pecos",
  "US - Texas - Polk",
  "US - Texas - Potter",
  "US - Texas - Presidio",
  "US - Texas - Rains",
  "US - Texas - Randall",
  "US - Texas - Reagan",
  "US - Texas - Real",
  "US - Texas - Red River",
  "US - Texas - Reeves",
  "US - Texas - Refugio",
  "US - Texas - Roberts",
  "US - Texas - Robertson",
  "US - Texas - Rockwall",
  "US - Texas - Runnels",
  "US - Texas - Rusk",
  "US - Texas - Sabine",
  "US - Texas - San Augustine",
  "US - Texas - San Jacinto",
  "US - Texas - San Patricio",
  "US - Texas - San Saba",
  "US - Texas - Schleicher",
  "US - Texas - Scurry",
  "US - Texas - Shackelford",
  "US - Texas - Shelby",
  "US - Texas - Sherman",
  "US - Texas - Smith",
  "US - Texas - Somervell",
  "US - Texas - Starr",
  "US - Texas - Stephens",
  "US - Texas - Sterling",
  "US - Texas - Stonewall",
  "US - Texas - Sutton",
  "US - Texas - Swisher",
  "US - Texas - Tarrant",
  "US - Texas - Taylor",
  "US - Texas - Terrell",
  "US - Texas - Terry",
  "US - Texas - Throckmorton",
  "US - Texas - Titus",
  "US - Texas - Tom Green",
  "US - Texas - Travis",
  "US - Texas - Trinity",
  "US - Texas - Tyler",
  "US - Texas - Upshur",
  "US - Texas - Upton",
  "US - Texas - Uvalde",
  "US - Texas - Val Verde",
  "US - Texas - Van Zandt",
  "US - Texas - Victoria",
  "US - Texas - Walker",
  "US - Texas - Waller",
  "US - Texas - Ward",
  "US - Texas - Washington",
  "US - Texas - Webb",
  "US - Texas - Wharton",
  "US - Texas - Wheeler",
  "US - Texas - Wichita",
  "US - Texas - Wilbarger",
  "US - Texas - Willacy",
  "US - Texas - Williamson",
  "US - Texas - Wilson",
  "US - Texas - Winkler",
  "US - Texas - Wise",
  "US - Texas - Wood",
  "US - Texas - Yoakum",
  "US - Texas - Young",
  "US - Texas - Zapata",
  "US - Texas - Zavala",
  "US - Utah - Bear River",
  "US - Utah - Central Utah",
  "US - Utah - Davis",
  "US - Utah - Salt Lake",
  "US - Utah - San Juan",
  "US - Utah - Southeast Utah",
  "US - Utah - Southwest Utah",
  "US - Utah - Summit",
  "US - Utah - Tooele",
  "US - Utah - TriCounty",
  "US - Utah - Utah",
  "US - Utah - Wasatch",
  "US - Utah - Weber-Morgan",
  "US - Vermont - Addison",
  "US - Vermont - Bennington",
  "US - Vermont - Caledonia",
  "US - Vermont - Chittenden",
  "US - Vermont - Franklin",
  "US - Vermont - Lamoille",
  "US - Vermont - Orange",
  "US - Vermont - Orleans",
  "US - Vermont - Rutland",
  "US - Vermont - Washington",
  "US - Vermont - Windham",
  "US - Vermont - Windsor",
  "US - Virgin Islands",
  "US - Virginia - Accomack",
  "US - Virginia - Albemarle",
  "US - Virginia - Alexandria",
  "US - Virginia - Alleghany",
  "US - Virginia - Amelia",
  "US Virginia - Amherst",
  "US - Virginia - Appomattox",
  "US - Virginia - Arlington",
  "US - Virginia - Augusta",
  "US - Virginia - Bedford",
  "US - Virginia - Bland",
  "US - Virginia - Botetourt",
  "US - Virginia - Bristol",
  "US - Virginia - Brunswick",
  "US - Virginia - Buchanan",
  "US - Virginia - Buckingham",
  "US - Virginia - Buena Vista",
  "US - Virginia - Campbell",
  "US - Virginia - Caroline",
  "US - Virginia - Carroll",
  "US - Virginia - Charles City",
  "US - Virginia - Charlotte",
  "US - Virginia - Charlottesville",
  "US - Virginia - Chesapeake",
  "US - Virginia - Chesterfield",
  "US - Virginia - Clarke",
  "US - Virginia - Colonial Heights",
  "US - Virginia - Covington",
  "US - Virginia - Craig",
  "US - Virginia - Culpeper",
  "US - Virginia - Cumberland",
  "US - Virginia - Danville",
  "US - Virginia - Dickenson",
  "US - Virginia - Dinwiddie",
  "US - Virginia - Emporia",
  "US - Virginia - Essex",
  "US - Virginia - Fairfax",
  "US - Virginia - Fairfax City",
  "US - Virginia - Falls Church",
  "US - Virginia - Fauquier",
  "US - Virginia - Floyd",
  "US - Virginia - Fluvanna",
  "US - Virginia - Franklin",
  "US - Virginia - Franklin City",
  "US - Virginia - Frederick",
  "US - Virginia - Fredericksburg",
  "US - Virginia - Galax",
  "US - Virginia - Giles",
  "US - Virginia - Gloucester",
  "US - Virginia - Goochland",
  "US - Virginia - Grayson",
  "US - Virginia - Greene",
  "US - Virginia - Greensville",
  "US - Virginia - Halifax",
  "US - Virginia - Hampton",
  "US - Virginia - Hanover",
  "US - Virginia - Harrisonburg",
  "US - Virginia - Henrico",
  "US - Virginia - Henry",
  "US - Virginia - Hopewell",
  "US - Virginia - Isle of Wight",
  "US - Virginia - James City",
  "US - Virginia - King George",
  "US - Virginia - King William",
  "US - Virginia - King and Queen",
  "US - Virginia - Lancaster",
  "US - Virginia - Lee",
  "US - Virginia - Lexington",
  "US - Virginia - Loudoun",
  "US - Virginia - Louisa",
  "US - Virginia - Lunenburg",
  "US - Virginia - Lynchburg",
  "US - Virginia - Madison",
  "US - Virginia - Manassas",
  "US - Virginia - Manassas Park",
  "US - Virginia - Martinsville",
  "US - Virginia - Mathews",
  "US - Virginia - Mecklenburg",
  "US - Virginia - Middlesex",
  "US - Virginia - Montgomery",
  "US - Virginia - Nelson",
  "US - Virginia - New Kent",
  "US - Virginia - Newport News",
  "US - Virginia - Norfolk",
  "US - Virginia - Northampton",
  "US - Virginia - Northumberland",
  "US - Virginia - Nottoway",
  "US - Virginia - Orange",
  "US - Virginia - Page",
  "US - Virginia - Patrick",
  "US - Virginia - Petersburg",
  "US - Virginia - Pittsylvania",
  "US - Virginia - Poquoson",
  "US - Virginia - Portsmouth",
  "US - Virginia - Powhatan",
  "US - Virginia - Prince Edward",
  "US - Virginia - Prince George",
  "US - Virginia - Prince William",
  "US - Virginia - Pulaski",
  "US - Virginia - Radford",
  "US - Virginia - Rappahannock",
  "US - Virginia - Richmond",
  "US - Virginia - Richmond City",
  "US - Virginia - Roanoke",
  "US - Virginia - Roanoke City",
  "US - Virginia - Rockbridge",
  "US - Virginia - Rockingham",
  "US - Virginia - Russell",
  "US - Virginia - Salem",
  "US - Virginia - Scott",
  "US - Virginia - Shenandoah",
  "US - Virginia - Smyth",
  "US - Virginia - Southampton",
  "US - Virginia - Spotsylvania",
  "US - Virginia - Stafford",
  "US - Virginia - Staunton",
  "US - Virginia - Suffolk",
  "US - Virginia - Surry",
  "US - Virginia - Sussex",
  "US - Virginia - Tazewell",
  "US - Virginia - Virginia Beach",
  "US - Virginia - Warren",
  "US - Virginia - Washington",
  "US - Virginia - Waynesboro",
  "US - Virginia - Westmoreland",
  "US - Virginia - Williamsburg",
  "US - Virginia - Winchester",
  "US - Virginia - Wise",
  "US - Virginia - Wythe",
  "US - Virginia - York",
  "US - Washington - Adams",
  "US - Washington - Asotin",
  "US - Washington - Benton",
  "US - Washington - Chelan",
  "US - Washington - Clallam",
  "US - Washington - Clark",
  "US - Washington - Columbia",
  "US - Washington - Cowlitz",
  "US - Washington - Douglas",
  "US - Washington - Ferry",
  "US - Washington - Franklin",
  "US - Washington - Garfield",
  "US - Washington - Grant",
  "US - Washington - Grays Harbor",
  "US - Washington - Island",
  "US - Washington - Jefferson",
  "US - Washington - King",
  "US - Washington - Kitsap",
  "US - Washington - Kittitas",
  "US - Washington - Klickitat",
  "US - Washington - Lewis",
  "US - Washington - Lincoln",
  "US - Washington - Mason",
  "US - Washington - Okanogan",
  "US - Washington - Pacific",
  "US - Washington - Pend Oreille",
  "US - Washington - Pierce",
  "US - Washington - Skagit",
  "US - Washington - Skamania",
  "US - Washington - Snohomish",
  "US - Washington - Spokane",
  "US - Washington - Stevens",
  "US - Washington - Thurston",
  "US - Washington - Walla Walla",
  "US - Washington - Whatcom",
  "US - Washington - Whitman",
  "US - Washington - Yakima",
  "US - West Virginia - Barbour",
  "US - West Virginia - Berkeley",
  "US - West Virginia - Boone",
  "US - West Virginia - Braxton",
  "US - West Virginia - Brooke",
  "US - West Virginia - Cabell",
  "US - West Virginia - Clay",
  "US - West Virginia - Doddridge",
  "US - West Virginia - Fayette",
  "US - West Virginia - Gilmer",
  "US - West Virginia - Grant",
  "US - West Virginia - Greenbrier",
  "US - West Virginia - Hampshire",
  "US - West Virginia - Hancock",
  "US - West Virginia - Hardy",
  "US - West Virginia - Harrison",
  "US - West Virginia - Jackson",
  "US - West Virginia - Jefferson",
  "US - West Virginia - Kanawha",
  "US - West Virginia - Lewis",
  "US - West Virginia - Lincoln",
  "US - West Virginia - Logan",
  "US - West Virginia - Marion",
  "US - West Virginia - Marshall",
  "US - West Virginia - Mason",
  "US - West Virginia - McDowell",
  "US - West Virginia - Mercer",
  "US - West Virginia - Mineral",
  "US - West Virginia - Mingo",
  "US - West Virginia - Monongalia",
  "US - West Virginia - Monroe",
  "US - West Virginia - Morgan",
  "US - West Virginia - Nicholas",
  "US - West Virginia - Ohio",
  "US - West Virginia - Pendleton",
  "US - West Virginia - Pleasants",
  "US - West Virginia - Pocahontas",
  "US - West Virginia - Preston",
  "US - West Virginia - Putnam",
  "US - West Virginia - Raleigh",
  "US - West Virginia - Randolph",
  "US - West Virginia - Ritchie",
  "US - West Virginia - Roane",
  "US - West Virginia - Summers",
  "US - West Virginia - Taylor",
  "US - West Virginia - Tucker",
  "US - West Virginia - Tyler",
  "US - West Virginia - Upshur",
  "US - West Virginia - Wayne",
  "US - West Virginia - Wetzel",
  "US - West Virginia - Wirt",
  "US - West Virginia - Wood",
  "US - West Virginia - Wyoming",
  "US - Wisconsin - Adams",
  "US - Wisconsin - Ashland",
  "US - Wisconsin - Barron",
  "US - Wisconsin - Bayfield",
  "US - Wisconsin - Brown",
  "US - Wisconsin - Buffalo",
  "US - Wisconsin - Burnett",
  "US - Wisconsin - Calumet",
  "US - Wisconsin - Chippewa",
  "US - Wisconsin - Clark",
  "US - Wisconsin - Columbia",
  "US - Wisconsin - Crawford",
  "US - Wisconsin - Dane",
  "US - Wisconsin - Dodge",
  "US - Wisconsin - Door",
  "US - Wisconsin - Douglas",
  "US - Wisconsin - Dunn",
  "US - Wisconsin - Eau Claire",
  "US - Wisconsin - Florence",
  "US - Wisconsin - Fond du Lac",
  "US - Wisconsin - Forest",
  "US - Wisconsin - Grant",
  "US - Wisconsin - Green",
  "US - Wisconsin - Green Lake",
  "US - Wisconsin - Iowa",
  "US - Wisconsin - Iron",
  "US - Wisconsin - Jackson",
  "US - Wisconsin - Jefferson",
  "US - Wisconsin - Juneau",
  "US - Wisconsin - Kenosha",
  "US - Wisconsin - Kewaunee",
  "US - Wisconsin - La Crosse",
  "US - Wisconsin - Lafayette",
  "US - Wisconsin - Langlade",
  "US - Wisconsin - Lincoln",
  "US - Wisconsin - Manitowoc",
  "US - Wisconsin - Marathon",
  "US - Wisconsin - Marinette",
  "US - Wisconsin - Marquette",
  "US - Wisconsin - Menominee",
  "US - Wisconsin - Milwaukee",
  "US - Wisconsin - Monroe",
  "US - Wisconsin - Oconto",
  "US - Wisconsin - Oneida",
  "US - Wisconsin - Outagamie",
  "US - Wisconsin - Ozaukee",
  "US - Wisconsin - Pepin",
  "US - Wisconsin - Pierce",
  "US - Wisconsin - Polk",
  "US - Wisconsin - Portage",
  "US - Wisconsin - Price",
  "US - Wisconsin - Racine",
  "US - Wisconsin - Richland",
  "US - Wisconsin - Rock",
  "US - Wisconsin - Rusk",
  "US - Wisconsin - Sauk",
  "US - Wisconsin - Sawyer",
  "US - Wisconsin - Shawano",
  "US - Wisconsin - Sheboygan",
  "US - Wisconsin - St. Croix",
  "US - Wisconsin - Taylor",
  "US - Wisconsin - Trempealeau",
  "US - Wisconsin - Vernon",
  "US - Wisconsin - Vilas",
  "US - Wisconsin - Walworth",
  "US - Wisconsin - Washburn",
  "US - Wisconsin - Washington",
  "US - Wisconsin - Waukesha",
  "US - Wisconsin - Waupaca",
  "US - Wisconsin - Waushara",
  "US - Wisconsin - Winnebago",
  "US - Wisconsin - Wood",
  "US - Wyoming - Albany",
  "US - Wyoming - Big Horn",
  "US - Wyoming - Campbell",
  "US - Wyoming - Carbon",
  "US - Wyoming - Converse",
  "US - Wyoming - Crook",
  "US - Wyoming - Fremont",
  "US - Wyoming - Goshen",
  "US - Wyoming - Hot Springs",
  "US - Wyoming - Johnson",
  "US - Wyoming - Laramie",
  "US - Wyoming - Lincoln",
  "US - Wyoming - Natrona",
  "US - Wyoming - Niobrara",
  "US - Wyoming - Park",
  "US - Wyoming - Platte",
  "US - Wyoming - Sheridan",
  "US - Wyoming - Sublette",
  "US - Wyoming - Sweetwater",
  "US - Wyoming - Teton",
  "US - Wyoming - Uinta",
  "US - Wyoming - Washakie",
  "US - Wyoming - Weston",
  "Uganda",
  "Ukraine - Cherkasy Oblast",
  "Ukraine - Chernihiv Oblast",
  "Ukraine - Chernivtsi Oblast",
  "Ukraine - Crimea Republic*",
  "Ukraine - Dnipropetrovsk Oblast",
  "Ukraine - Donetsk Oblast",
  "Ukraine - Ivano-Frankivsk Oblast",
  "Ukraine - Kharkiv Oblast",
  "Ukraine - Kherson Oblast",
  "Ukraine - Khmelnytskyi Oblast",
  "Ukraine - Kiev",
  "Ukraine - Kiev Oblast",
  "Ukraine - Kirovohrad Oblast",
  "Ukraine - Luhansk Oblast",
  "Ukraine - Lviv Oblast",
  "Ukraine - Mykolaiv Oblast",
  "Ukraine - Odessa Oblast",
  "Ukraine - Poltava Oblast",
  "Ukraine - Rivne Oblast",
  "Ukraine - Sevastopol*",
  "Ukraine - Sumy Oblast",
  "Ukraine - Ternopil Oblast",
  "Ukraine - Vinnytsia Oblast",
  "Ukraine - Volyn Oblast",
  "Ukraine - Zakarpattia Oblast",
  "Ukraine - Zaporizhia Oblast",
  "Ukraine - Zhytomyr Oblast",
  "United Arab Emirates",
  "United Kingdom - Bermuda",
  "United Kingdom - British Virgin Islands",
  "United Kingdom - Cayman Islands",
  "United Kingdom - Channel Islands",
  "United Kingdom - England",
  "United Kingdom - Gibraltar",
  "United Kingdom - Isle of Man",
  "United Kingdom - Montserrat",
  "United Kingdom - Northern Ireland",
  "United Kingdom - Scotland",
  "United Kingdom - Turks and Caicos Islands",
  "United Kingdom - Wales",
  "Uruguay",
  "Uzbekistan",
  "Venezuela",
  "Vietnam",
  "West Bank and Gaza",
  "Yemen",
  "Zambia",
  "Zimbabwe"
]